// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-05T21:10:48.971Z
// Property: Sir Charles Court (ID: 6767906449166881)
// Collections: 35 amenities, 4 floorplans (live), 37 photos, 80 POIs, 4 reviews, 2 virtual tours, 7 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162446",
  "multihub_property_id": "6767906449166881",
  "property_external_id": "495832",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/sir-charles-court-beaverton-or/d0bssmk/",
  "property_google_business_url": "https://www.google.com/maps/place/Sir+Charles+Court+Apartments/data=!4m2!3m1!1s0x0:0x975aae17074b66ef?sa=X&ved=2ahUKEwji1MzCgbySAxX3UGcHHQHJOgkQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "52024037808",
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "495832 p0505500",
  "property_status": null,
  "property_slug": "sir-charles-court",
  "property_name": "Sir Charles Court",
  "property_website_url": "www.beaverton-oregon-apartments.com",
  "property_domain": "https://www.beaverton-oregon-apartments.com/",
  "property_address": "2301 NW Schmidt Way",
  "property_full_address": "2301 NW Schmidt Way, Beaverton, OR, 97006",
  "property_address_1": "2301 NW Schmidt Way",
  "property_address_2": null,
  "property_address_city": "Beaverton",
  "property_address_state": "OR",
  "property_address_zip_full": null,
  "property_address_zip": "97006",
  "property_address_country": "US",
  "property_address_county": "Washington County",
  "property_neighborhood_address": "Oak Hills",
  "property_address_latitude": "45.5366491",
  "property_address_longitude": "-122.8482372",
  "property_email": "sircharles@ctlmanagement.com",
  "property_phone": "(503) 994-4172",
  "property_call_tracking_phone": null,
  "property_company_name": "CTL Management ",
  "property_company_url": "https://ctlmanagement.randallgroup.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "At Sir Charles Court in Beaverton, OR, vibrant living awaits with our spacious one, two, and three-bedroom floor plans. Enjoy amenities like a sparkling pool, fitness center, and serene walking trails, all designed to enhance your lifestyle. Make this community your next home—schedule a tour today!",
  "property_long_description": "Welcome to Sir Charles Court, your ideal apartment community nestled in the heart of Beaverton, OR! Our thoughtfully designed floor plans offer a variety of options to suit your lifestyle, including spacious one-bedroom, two-bedroom, and three-bedroom apartments that provide the perfect balance of comfort and convenience. \n\nAt Sir Charles Court, we prioritize your well-being with an exceptional array of amenities. Dive into relaxation at our sparkling pool or unwind in the rejuvenating hot tub and spa. Stay active in our state-of-the-art fitness center or enjoy friendly competition on our basketball court. Kids will love the playground, while you can work seamlessly from our business center or take advantage of our convenient package service.\n\nOur property is designed for effortless living, featuring on-site maintenance and property management to ensure your needs are promptly met. Enjoy modern comforts in your apartment with key features like high-speed internet access, washer/dryer, dishwasher, and ample storage space, including walk-in closets. Choose from stylish finishes such as vinyl flooring, vaulted ceilings, and private balconies or patios that offer stunning views.\n\nLocated near beautiful walking and biking trails, Sir Charles Court is a smoke-free community that promotes eco-friendly living with recycling options. Don’t wait any longer to find your new home! Browse our availability or schedule a personal tour today to discover everything our vibrant community has to offer. Experience Beaverton living at its finest at Sir Charles Court!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019db18f-5f65-7668-83b5-4db7afbe5b76.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of apartment buildings with manicured lawns and trees.",
    "public_id": "019db18f-5f65-7668-83b5-4db7afbe5b76",
    "storage_key": "property/6767906449166881/019db18f-5f65-7668-83b5-4db7afbe5b76.webp",
    "width": 1920,
    "height": 896
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "396",
  "property_year_built": "1996",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "95.95959595959596",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Deposit: $400",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "0",
  "property_pet_deposit": "400",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "25",
  "property_pet_restrictions": " ",
  "property_pet_policy_description": "Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old. Deposit and monthly pet rent are per pet.  Small caged animals are allowed without a deposit and pet rent. Small caged animals that are allowed are common domesticated household birds, hamsters, gerbils, rabbits, guinea pigs, chinchillas and aquarium/terrarium animals including fish, hermit crabs, turtles, frogs, and small lizards.  Animals such as birds of prey, iguanas, ferrets, snakes, rats, mice, insects, arachnids (including spiders and scorpions), livestock, or any other exotic animals are not allowed. No animals are allowed that are venomous, biting, stinging, constricting, or pose a threat of infestation. Small animals are limited to a maximum of two, with the exception of fish which should be kept to a reasonable amount, and must be kept confined in appropriate and reasonably sized cages or aquariums/terrariums.  Resident shall not have more than three aquariums and the total combined capacity between all aquariums shall not exceed 40 gallons.",
  "property_petpolicy_info": "Maximum Number of Pets: 2 (Only indoor adult cats and indoor adult dogs are allowed; adult is defined as at least one year old)\nMaximum Weight Limit: 25 pounds\nMonthly Pet Rent: $25 per pet\nDeposit: $400 per pet",
  "property_online_leasing_url": "https://beaverton-oregon-apartments.securecafe.com/onlineleasing/sir-charles-court/floorplans.aspx",
  "property_resident_portal_url": "https://beaverton-oregon-apartments.securecafe.com/residentservices/sir-charles-court/userlogin.aspx",
  "property_apply_now_url": "https://beaverton-oregon-apartments.securecafe.com/onlineleasing/sir-charles-court/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019db1a3-890d-710e-864f-158bd3a1d12b.webp",
  "property_primary_logo_media": {
    "alt_text": "Sir Charles Court Apartments logo",
    "public_id": "019db1a3-890d-710e-864f-158bd3a1d12b",
    "storage_key": "property/6767906449166881/019db1a3-890d-710e-864f-158bd3a1d12b.webp",
    "width": 819,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019db1a3-af67-7423-9461-6f5275aafe6f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Sir Charles Court Apartments logo",
    "public_id": "019db1a3-af67-7423-9461-6f5275aafe6f",
    "storage_key": "property/6767906449166881/019db1a3-af67-7423-9461-6f5275aafe6f.webp",
    "width": 820,
    "height": 160
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019db1a5-23fd-709b-9a12-9e4f1366c8ed.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Sir Charles Court Apartments Logo",
    "public_id": "019db1a5-23fd-709b-9a12-9e4f1366c8ed",
    "storage_key": "property/6767906449166881/019db1a5-23fd-709b-9a12-9e4f1366c8ed.webp",
    "width": 819,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019db1a5-1793-76ed-9760-29742a538968.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Sir Charles Court Apartments logo",
    "public_id": "019db1a5-1793-76ed-9760-29742a538968",
    "storage_key": "property/6767906449166881/019db1a5-1793-76ed-9760-29742a538968.webp",
    "width": 819,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
  "property_company_logo_media": {
    "alt_text": "CTL Management logo",
    "public_id": "019d9c74-7219-719e-b7ea-ff6185375ae5",
    "storage_key": "company/5767906449162446/019d9c74-7219-719e-b7ea-ff6185375ae5.webp",
    "width": 201,
    "height": 60
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#14473D",
  "property_secondary_color": "#9EBAC2",
  "property_font_color": "#14473D",
  "property_color_4": "#F27859",
  "property_color_3": "#4F756E",
  "property_color_5": "#FAAD45",
  "property_color_6": "#FCF5F0",
  "property_color_7": "#CFDBE0",
  "property_color_8": "#FCE3BD",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "719 - 1105",
  "property_sqft_min": "719",
  "property_sqft_max": "1105",
  "property_price_range": "1385 - 2840",
  "property_price_min": "1385",
  "property_price_max": "2840",
  "property_available_units": 16,
  "property_facebook_url": "https://www.facebook.com/SirCharlesCourtApartmentHomes/",
  "property_instagram_url": null,
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJq4tDPEgPlVQR72ZLBxeuWpc",
  "property_youtube_url": "https://www.youtube.com/watch?t=338&v=Fw5PAnInXeM",
  "property_yelp_url": "https://www.yelp.com/biz/sir-charles-court-apartments-beaverton",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Sir Charles Court",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to Sir Charles Court in Beaverton, OR, where comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom apartments that elevate your lifestyle. Enjoy resort-style amenities like a refreshing pool, a well-equipped fitness center, and scenic walking trails, all wrapped in a vibrant community spirit.",
  "property_home_floorplans_blurb": "Nestled in the heart of Beaverton, Sir Charles Court offers a collection of thoughtfully designed apartment homes. With versatile floor plans to suit every lifestyle, you’ll find the ideal space that reflects your unique taste. Browse our available options and transform your living experience today, right here in Beaverton!",
  "property_home_gallery_blurb": "Welcome to Sir Charles Court, where comfort meets convenience in the heart of Beaverton, OR. Choose from spacious one, two, or three-bedroom floor plans designed for your lifestyle. Enjoy resort-style amenities, including a shimmering pool, state-of-the-art fitness center, and serene walking trails. Picture yourself living here!",
  "property_home_neighborhood_blurb": "Welcome to Sir Charles Court, where spacious one, two, and three-bedroom apartments meet vibrant community life in Beaverton, OR. Surrounded by stunning parks, top-notch fitness centers, and local attractions like the Rice Northwest Museum of Rocks & Minerals, there’s always something to enrich your lifestyle just around the corner.",
  "property_home_reviews_blurb": "At Sir Charles Court in Beaverton, OR, residents cherish the vibrant community spirit and exceptional amenities. One satisfied tenant exclaims, “The atmosphere is welcoming, and I love my spacious apartment!” See what our residents have to say about living at our community and experience the joy of calling Sir Charles Court home!",
  "property_neighborhood_blurb": "At Sir Charles Court in Beaverton, OR, your home is just steps away from vibrant local attractions. Enjoy access to serene parks like Tualatin Hills Nature Park or explore the fascinating Rice Northwest Museum of Rocks & Minerals. Uncover the rich tapestry of our neighborhood and immerse yourself in all it offers!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "Welcome to Sir Charles Court in Beaverton, OR, where comfort meets convenience. Choose from spacious one, two, or three-bedroom layouts, each boasting modern amenities like high-speed internet, walk-in closets, and stunning views. Dive into a refreshing pool or unwind in our spa—all within a vibrant, smoke-free community. Join us today!",
  "property_applynow_blurb": "At Sir Charles Court in Beaverton, OR, choose from spacious one, two, or three-bedroom floor plans designed for comfort and style. Enjoy exceptional amenities like a sparkling pool, modern fitness center, and scenic walking trails. Start a new chapter—lease your perfect home today with our easy online application!",
  "property_contactus_blurb": "At Sir Charles Court in Beaverton, OR, our diverse floor plans cater to every lifestyle, from cozy one-bedroom retreats to spacious three-bedroom havens. Experience comfortable living framed by lush surroundings. Have questions? Reach out to our leasing team today for personalized assistance and find your perfect home!",
  "property_faqs_blurb": "At Sir Charles Court in Beaverton, OR, our diverse floor plans cater to every lifestyle, featuring one, two, and three-bedroom apartments. Have questions? Our FAQs page offers insightful answers about our community, ensuring you find the perfect home. Engage with us today to elevate your living experience!",
  "property_floorplans_blurb": "At Sir Charles Court in Beaverton, OR, our thoughtfully designed floor plans—ranging from cozy one-bedrooms to spacious three-bedrooms—cater to diverse lifestyles. Each layout balances comfort and style, ensuring you feel right at home. Browse our available apartment homes and find the perfect fit for you today!",
  "property_gallery_blurb": "At Sir Charles Court in Beaverton, OR, picture yourself relaxing by the sparkling pool or unwinding in the hot tub after a workout in our state-of-the-art fitness center. With spacious one, two, and three-bedroom floor plans and a vibrant community, your perfect home awaits. ",
  "property_interactivemap_blurb": "At Sir Charles Court in Beaverton, OR, our inviting apartments are designed for every lifestyle with one, two, and three-bedroom floor plans. Enjoy premium amenities like a sparkling pool, state-of-the-art fitness center, and serene walking trails. Check out our interactive community map to find your perfect home today!",
  "property_pets_blurb": "At Sir Charles Court in Beaverton, OR, your furry friends are cherished! We proudly accommodate indoor adult cats and dogs under 25 lbs., ensuring a cozy home for your beloved companions. With a vibrant community atmosphere and thoughtful pet-friendly policies, living here feels just like home—for you and your pets.",
  "property_referafriend_blurb": "At Sir Charles Court in Beaverton, OR, choose from thoughtfully designed one, two, or three-bedroom floor plans that perfectly suit your lifestyle. Great friends make great neighbors—refer a friend to our welcoming community today and enjoy the perks of living alongside those you love! ",
  "property_residentaccess_blurb": "Welcome to Sir Charles Court in Beaverton, OR, where comfort meets convenience. Choose from thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Access your resident portal now to effortlessly pay rent, schedule maintenance, and stay connected within our vibrant community!",
  "property_reviews_blurb": "At Sir Charles Court in Beaverton, OR, our residents rave about the warm community vibe and exceptional amenities. One resident shared, “The staff are incredibly helpful, making it feel like home.” Delve into our reviews to see what makes living here a cherished experience!",
  "property_created_at": "1762784622624",
  "property_scheduletour_blurb": "At Sir Charles Court in Beaverton, OR, our thoughtfully designed floor plans—one, two, and three bedrooms—offer the perfect blend of comfort and style. Ready to experience our community? Schedule a tour and find out why residents love calling Sir Charles Court home! ",
  "property_thankyou_blurb": "Thank you for your interest in Sir Charles Court in Beaverton, OR. With thoughtfully designed one, two, and three-bedroom floor plans, your perfect home awaits. A member of our team will reach out shortly to assist you in finding your ideal living space. We can’t wait to connect!",
  "property_virtualtours_blurb": "At Sir Charles Court in Beaverton, OR, choose from spacious one, two, and three-bedroom floor plans designed for your lifestyle. Immerse yourself in our inviting community through an interactive virtual tour. Witness the charm and comfort that await you—your ideal home is just a click away!",
  "property_copyright": "2025 All Rights Reserved. Sir Charles Court",
  "property_seo_title_home": "Sir Charles Court |  Apartments in Beaverton, OR",
  "property_seo_description_home": "Experience unparalleled comfort at Sir Charles Court in Beaverton, OR. Choose from spacious one to three-bedroom apartments with resort-style amenities.",
  "property_seo_title_floorplans": "Floor Plans | Beaverton, OR Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Sir Charles Court in Beaverton, OR. From cozy one-bedrooms to spacious three-bedrooms, explore our unique floor plans today!",
  "property_seo_title_amenities": "Amenities | Beaverton, OR Apartments for Rent",
  "property_seo_description_amenities": "Discover modern living at Sir Charles Court, Beaverton, OR! Enjoy a pool, fitness center, and spacious apartments with stunning views. Your dream home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Beaverton, OR",
  "property_seo_description_gallery": "Experience modern living at Sir Charles Court in Beaverton, OR! Picture yourself enjoying poolside lounges, spacious floor plans, and vibrant amenities.",
  "property_seo_title_virtualtours": "Virtual Tours | Sir Charles Court Apartments",
  "property_seo_description_virtualtours": "Experience upscale living at Sir Charles Court in Beaverton, OR. Take a virtual tour today and find your perfect one, two, or three-bedroom apartment!",
  "property_seo_title_interactivemap": "Interactive Map | Sir Charles Court Apartments",
  "property_seo_description_interactivemap": "Find your ideal home at Sir Charles Court in Beaverton, OR! Use our interactive map to explore unique floor plans, amenities, and your future lifestyle today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Beaverton, OR",
  "property_seo_description_neighborhood": "Uncover the charm of Beaverton at Sir Charles Court. Dive into local gems and vibrant hotspots just steps from your future home.",
  "property_seo_title_contact": "Contact Us | Sir Charles Court",
  "property_seo_description_contact": "Connect with our leasing team at Sir Charles Court in Beaverton, OR, to find your perfect one, two, or three-bedroom apartment. We're here to help!",
  "property_seo_title_faqs": "FAQs | Apartments in Beaverton, OR",
  "property_seo_description_faqs": "Uncover the answers to your burning questions about Sir Charles Court in Beaverton, OR. Dive into our FAQs for details on amenities, floor plans, and more!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Beaverton, OR",
  "property_seo_description_reviews": "Discover life at Sir Charles Court in Beaverton, OR! Explore resident reviews and see why our one-to-three-bedroom apartments feel like home.",
  "property_seo_title_applynow": "Apply Now | Apartments in Beaverton, OR",
  "property_seo_description_applynow": "Experience upscale living at Sir Charles Court in Beaverton, OR. Choose from spacious one to three-bedroom apartments and enjoy premium amenities. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Sir Charles Court",
  "property_seo_description_residentaccess": "Access the Sir Charles Court resident portal for easy rent payments, maintenance requests, and community updates in Beaverton, OR!",
  "property_seo_title_referafriend": "Refer A Friend | Sir Charles Court",
  "property_seo_description_referafriend": "Refer a friend to Sir Charles Court in Beaverton, OR! Great friends make great neighbors—share the joy of your home and enjoy exclusive perks together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Sir Charles Court",
  "property_seo_description_scheduletour": "Experience the charm of Sir Charles Court in Beaverton, OR. Schedule a tour today to explore your future home and vibrant community life!",
  "property_seo_title_privacy": "Privacy Policy | Sir Charles Court",
  "property_seo_description_privacy": "Protecting your data is our priority at Sir Charles Court. Dive into our privacy policy and learn how we guard your privacy in beautiful Beaverton, OR.",
  "property_seo_title_accessibility": "Website Accessibility | Sir Charles Court",
  "property_seo_description_accessibility": "At Sir Charles Court, we prioritize digital inclusion and accessibility, ensuring a comfortable living experience for everyone in Beaverton.",
  "property_seo_title_sitemap": "Sitemap | Sir Charles Court",
  "property_seo_description_sitemap": "Navigate your way to the perfect home at Sir Charles Court in Beaverton, OR. Check out our sitemap for easy access to all our amenities and offerings!",
  "property_seo_title_thankyou": "Thank You | Sir Charles Court",
  "property_seo_description_thankyou": "Thank you for reaching out to Sir Charles Court! A team member will connect with you soon to discuss your future home in beautiful Beaverton, OR.",
  "property_seo_title_pets": "Pet Policy | Apartments in Beaverton, OR",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1778874993556",
  "amenities": [
    {
      "id": "ec_05fbf5dd73770c935acfd519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429429",
      "title": "Clubhouse with Complimentary Wi-Fi",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-4e71-758c-9fc7-800af841bcbb.webp",
      "amenity_image_media": {
        "alt_text": "Lounge area with a large sectional sofa, ottoman, and fireplace.",
        "public_id": "019d08aa-4e71-758c-9fc7-800af841bcbb",
        "storage_key": "property/6767906449166881/019d08aa-4e71-758c-9fc7-800af841bcbb.webp",
        "width": 3072,
        "height": 2304
      },
      "amenity_image_alt_text": "clubhouse fireplace lounge at Sir Charles Court Apartments, OR 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1fd83fc212a93c4c7c33084f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429427",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-3fea-7448-9377-3d6546d9a56c.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "019d08aa-3fea-7448-9377-3d6546d9a56c",
        "storage_key": "property/6767906449166881/019d08aa-3fea-7448-9377-3d6546d9a56c.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Business center at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0b9a34fccb6c0985317c0c77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429422",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-5bb3-7216-90cf-21085b34d5ce.webp",
      "amenity_image_media": {
        "alt_text": "Interior of a gym with weight machines and mirrors, large windows overlook greenery.",
        "public_id": "019d08aa-5bb3-7216-90cf-21085b34d5ce",
        "storage_key": "property/6767906449166881/019d08aa-5bb3-7216-90cf-21085b34d5ce.webp",
        "width": 3072,
        "height": 2270
      },
      "amenity_image_alt_text": "fitness center strength equipment at Sir Charles Court Apartments, Beaverton, 97006,fitness center equipment machines at Sir Charles Court Apartments, Beaverton, OR",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6efea0c02d9e03cc64223d2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429439",
      "title": "Year Round Indoor Spa",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-6fbc-756d-a931-1eaf8963752a.webp",
      "amenity_image_media": {
        "alt_text": "Indoor hot tub with wooden ceiling and tiled walls.",
        "public_id": "019d08aa-6fbc-756d-a931-1eaf8963752a",
        "storage_key": "property/6767906449166881/019d08aa-6fbc-756d-a931-1eaf8963752a.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Indoor Spa at Sir Charles Court Apartments, Beaverton, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_522d83b6ac84763f91c45717",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429440",
      "title": "Seasonal Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-76cb-7054-8f52-3a88025c525d.webp",
      "amenity_image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d08aa-76cb-7054-8f52-3a88025c525d",
        "storage_key": "property/6767906449166881/019d08aa-76cb-7054-8f52-3a88025c525d.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Swimming pool at Sir Charles Court Apartments, Beaverton, Oregon 97006,Pool deck and lounge chairs at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_76ba00516ecc0a34b2347d23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429424",
      "title": "2 Outdoor Playgrounds",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b0b6-77df-8d72-6432de799ff4.webp",
      "amenity_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d08aa-b0b6-77df-8d72-6432de799ff4",
        "storage_key": "property/6767906449166881/019d08aa-b0b6-77df-8d72-6432de799ff4.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Playground at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dcb6884103a6fa27b895fc22",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "87846153",
      "title": "Basketball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b49f-748e-8560-ff1eee6bb8ef.webp",
      "amenity_image_media": {
        "alt_text": "Basketball court and apartment building exterior with trees and blue sky.",
        "public_id": "019d08aa-b49f-748e-8560-ff1eee6bb8ef",
        "storage_key": "property/6767906449166881/019d08aa-b49f-748e-8560-ff1eee6bb8ef.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Basketball court at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb418af492b41c978b7a543f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429434",
      "title": "Garages With Remote Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-e66f-7728-bb10-9448c45ad2cc.webp",
      "amenity_image_media": {
        "alt_text": "Row of garage doors in a multifamily property parking lot.",
        "public_id": "019d08aa-e66f-7728-bb10-9448c45ad2cc",
        "storage_key": "property/6767906449166881/019d08aa-e66f-7728-bb10-9448c45ad2cc.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Garages at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_467c30c62c0cb9970a4566b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429428",
      "title": "Carports",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b915-7735-a0ea-c4d20b9414fa.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with cars in front of apartment buildings.",
        "public_id": "019d08aa-b915-7735-a0ea-c4d20b9414fa",
        "storage_key": "property/6767906449166881/019d08aa-b915-7735-a0ea-c4d20b9414fa.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "Three story building and carports at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_df2304464f0bbdfb56b5a04f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86393010",
      "title": "Coffee Bar",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_752c9fb7fa47aa7d78a6bb66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80683672",
      "title": "Billiards Room",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-40f9-753c-b3b6-17aa34f5dc7f.webp",
      "amenity_image_media": {
        "alt_text": "Billiards table in a game room.",
        "public_id": "019d08aa-40f9-753c-b3b6-17aa34f5dc7f",
        "storage_key": "property/6767906449166881/019d08aa-40f9-753c-b3b6-17aa34f5dc7f.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Billiards Room at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0ace955a539d7fdc5b4a9082",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "122131550",
      "title": "Seasonal Wading Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-9722-705f-a010-4f736e61aef9.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool and built-in grill area with lounge chairs, next to apartment buildings.",
        "public_id": "019d08aa-9722-705f-a010-4f736e61aef9",
        "storage_key": "property/6767906449166881/019d08aa-9722-705f-a010-4f736e61aef9.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Outdoor wading pool at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_39fe1170cea8bd260385c151",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "87410410",
      "title": "24-Hour Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-a165-7660-99fb-d2e6ad7e56a7.webp",
      "amenity_image_media": {
        "alt_text": "Amazon Hub package lockers with digital interface and keypad.",
        "public_id": "019d08aa-a165-7660-99fb-d2e6ad7e56a7",
        "storage_key": "property/6767906449166881/019d08aa-a165-7660-99fb-d2e6ad7e56a7.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Self service package lockers at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24ac45c09883fc1ebc44eaa4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457291",
      "title": "Steps away from Waterhouse Trail",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_02d65718f002e5ed24460f02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86393009",
      "title": "Clubhouse Rentals",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-4e95-7708-9d68-88ce64d44a20.webp",
      "amenity_image_media": {
        "alt_text": "Spacious lounge with a fireplace, comfortable seating, and a bar area.",
        "public_id": "019d08aa-4e95-7708-9d68-88ce64d44a20",
        "storage_key": "property/6767906449166881/019d08aa-4e95-7708-9d68-88ce64d44a20.webp",
        "width": 3072,
        "height": 2304
      },
      "amenity_image_alt_text": "clubhouse kitchen bar seating and fireplace lounge at Sir Charles Court Apartments, Oregon, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_78bdae17a206dbe6cba3b052",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86393013",
      "title": "Flexible Lease Terms",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f902d82296d188b93e7566d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457290",
      "title": "Resident Referral Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c4b499089d0f6c786635049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429437",
      "title": "Resident Activity Program",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f01dff62e0868aa6e19b14e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "82390263",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_47a3e0385d96cb51d58f3274",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "82390265",
      "title": "Online Service Requests",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9d1eb386a83937fbc7a355f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86393014",
      "title": "Smoke Free Housing",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_95cc47371e218752f6073a05",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429446",
      "title": "In-Unit Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-17c1-7128-ac2f-762ab11bc8ec.webp",
      "amenity_image_media": {
        "alt_text": "Washer and dryer with cleaning supplies in a hallway",
        "public_id": "019d08aa-17c1-7128-ac2f-762ab11bc8ec",
        "storage_key": "property/6767906449166881/019d08aa-17c1-7128-ac2f-762ab11bc8ec.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Hallway & Laundry at Sir Charles Court Apartments, Oregon",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d43769e6dfeb107a2625cd93",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429444",
      "title": "Patio or Deck",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-d1e3-7593-9351-1da572c9d0cd.webp",
      "amenity_image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees under a blue sky.",
        "public_id": "019d08aa-d1e3-7593-9351-1da572c9d0cd",
        "storage_key": "property/6767906449166881/019d08aa-d1e3-7593-9351-1da572c9d0cd.webp",
        "width": 2048,
        "height": 1463
      },
      "amenity_image_alt_text": "Three story building exterior and green space at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8d35532e498373b2c8407e94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429443",
      "title": "Large Attached Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_891dea64014d156347cb1d11",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429442",
      "title": "Vaulted Ceilings - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da6ae3184e693181532f4ecd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "80429445",
      "title": "Walk-In Closets - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dcd3fab3b935957533d1011",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457300",
      "title": "Reserved Parking",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b915-7735-a0ea-c4d20b9414fa.webp",
      "amenity_image_media": {
        "alt_text": "Covered parking spaces with cars in front of apartment buildings.",
        "public_id": "019d08aa-b915-7735-a0ea-c4d20b9414fa",
        "storage_key": "property/6767906449166881/019d08aa-b915-7735-a0ea-c4d20b9414fa.webp",
        "width": 2048,
        "height": 1367
      },
      "amenity_image_alt_text": "Three story building and carports at Sir Charles Court Apartments, Beaverton, Oregon 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4acfa7c507d948043c5845cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457302",
      "title": "Large Picturesque Living Room Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-0621-710e-9f6c-3a9b67d21202.webp",
      "amenity_image_media": {
        "alt_text": "Living room with an armchair, coffee table, and accent console, leading to a bathroom.",
        "public_id": "019d08aa-0621-710e-9f6c-3a9b67d21202",
        "storage_key": "property/6767906449166881/019d08aa-0621-710e-9f6c-3a9b67d21202.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Apartment Living Room & Window at Sir Charles Court Apartments, Oregon, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c1489c986961feba2ae4e4d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457296",
      "title": "Closet Organizers",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e34ae6da9ade3e8b0860200e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457301",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08a9-f7e8-7024-a443-2b7734790b6e.webp",
      "amenity_image_media": {
        "alt_text": "Living room and kitchen area with dining table",
        "public_id": "019d08a9-f7e8-7024-a443-2b7734790b6e",
        "storage_key": "property/6767906449166881/019d08a9-f7e8-7024-a443-2b7734790b6e.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Living Room Kitchen Bar at Sir Charles Court Apartments, Beaverton, 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2b5d7adece83502c23857411",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457299",
      "title": "Upgraded Units Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59b94dfdf8e6e0f247125a53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457298",
      "title": "Roommate Friendly Floor Plans",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6098113fedfaec298241d87c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457303",
      "title": "Cable and Internet Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c287a4a530c730ad2bde4d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457304",
      "title": "Built-In Vanity In Primary Bedroom - In Select Homes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-09c4-7339-be28-51896c362a07.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with dresser, closet, and vanity.",
        "public_id": "019d08aa-09c4-7339-be28-51896c362a07",
        "storage_key": "property/6767906449166881/019d08aa-09c4-7339-be28-51896c362a07.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Master Bedroom Closet & Vanity at Sir Charles Court Apartments, Beaverton, OR",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_72ce0e9265b6a881d8656007",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "yardi",
      "external_id": "86457297",
      "title": "Mirrored Closet Doors - In Select Homes*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-09a7-70da-9183-d29ab4bc16cb.webp",
      "amenity_image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and window.",
        "public_id": "019d08aa-09a7-70da-9183-d29ab4bc16cb",
        "storage_key": "property/6767906449166881/019d08aa-09a7-70da-9183-d29ab4bc16cb.webp",
        "width": 1024,
        "height": 732
      },
      "amenity_image_alt_text": "Master Bedroom & Mirrored Closet  at Sir Charles Court Apartments, OR 97006",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_56dc1fa39afce982dcd5872e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08a9-fac1-74c9-b1a2-1ec382ed83d2.webp",
      "image_media": {
        "alt_text": "Sir Charles monument sign with flags and landscaping.",
        "public_id": "019d08a9-fac1-74c9-b1a2-1ec382ed83d2",
        "storage_key": "property/6767906449166881/019d08a9-fac1-74c9-b1a2-1ec382ed83d2.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Welcome to Sir Charles apartments, featuring a beautiful monument sign with vibrant landscaping and flags.",
      "link": "false",
      "alt_text": "Sir Charles monument sign with flags and landscaping.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_MonumentSign.jpg"
    },
    {
      "id": "ec_baa529506fedd82d0ba6cd29",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08a9-f7a3-73f9-a501-999f59d41765.webp",
      "image_media": {
        "alt_text": "Kitchen with white cabinets, black refrigerator, stove, and microwave.",
        "public_id": "019d08a9-f7a3-73f9-a501-999f59d41765",
        "storage_key": "property/6767906449166881/019d08a9-f7a3-73f9-a501-999f59d41765.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Explore this well-equipped kitchen featuring white cabinetry, a refrigerator, stove, and microwave. Perfect for preparing meals.",
      "link": "false",
      "alt_text": "Kitchen with white cabinets, black refrigerator, stove, and microwave.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelKitchenUpgraded.jpg"
    },
    {
      "id": "ec_9288c047f511c5232ad7a2b0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08a9-f796-72d9-afc3-417f4808511d.webp",
      "image_media": {
        "alt_text": "Living room and dining area with plush blue sofa, coffee table, and bar seating.",
        "public_id": "019d08a9-f796-72d9-afc3-417f4808511d",
        "storage_key": "property/6767906449166881/019d08a9-f796-72d9-afc3-417f4808511d.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living and dining area featuring a comfortable blue sofa, elegant coffee table, and bar stools, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "Living room and dining area with plush blue sofa, coffee table, and bar seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelLivingRoomDiningArea.jpg"
    },
    {
      "id": "ec_74e21b4e5eac2ecdd0d280ce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08a9-f7e8-7024-a443-2b7734790b6e.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with dining table",
        "public_id": "019d08a9-f7e8-7024-a443-2b7734790b6e",
        "storage_key": "property/6767906449166881/019d08a9-f7e8-7024-a443-2b7734790b6e.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious living room with a large TV and plush sofa, opening to a dining area and modern kitchen. Offers a comfortable and inviting atmosphere.",
      "link": "false",
      "alt_text": "Living room and kitchen area with dining table",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelLivingRoomKitchenBar.jpg"
    },
    {
      "id": "ec_4930360fccff1b76bcd20e28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-0621-710e-9f6c-3a9b67d21202.webp",
      "image_media": {
        "alt_text": "Living room with an armchair, coffee table, and accent console, leading to a bathroom.",
        "public_id": "019d08aa-0621-710e-9f6c-3a9b67d21202",
        "storage_key": "property/6767906449166881/019d08aa-0621-710e-9f6c-3a9b67d21202.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Relax and unwind in this inviting living space, complete with a comfortable armchair, coffee table, and an adjacent bathroom for your convenience.",
      "link": "false",
      "alt_text": "Living room with an armchair, coffee table, and accent console, leading to a bathroom.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelLivingRoomWindow.jpg"
    },
    {
      "id": "ec_ac4871e29f05705896026e1e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-09a7-70da-9183-d29ab4bc16cb.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-sized bed, dresser, and window.",
        "public_id": "019d08aa-09a7-70da-9183-d29ab4bc16cb",
        "storage_key": "property/6767906449166881/019d08aa-09a7-70da-9183-d29ab4bc16cb.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed, a large dresser, and ample natural light from the window.",
      "link": "false",
      "alt_text": "Bedroom with a king-sized bed, dresser, and window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelMasterBedroomMirroredCloset.jpg"
    },
    {
      "id": "ec_b243c8f037ec463afe1c171e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-09c4-7339-be28-51896c362a07.webp",
      "image_media": {
        "alt_text": "Bedroom with dresser, closet, and vanity.",
        "public_id": "019d08aa-09c4-7339-be28-51896c362a07",
        "storage_key": "property/6767906449166881/019d08aa-09c4-7339-be28-51896c362a07.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Cozy bedroom featuring a dresser, a spacious closet with mirrored doors, and a convenient vanity area.",
      "link": "false",
      "alt_text": "Bedroom with dresser, closet, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelMasterBedroomClosetVanity.jpg"
    },
    {
      "id": "ec_c467cb932e2a5c46f351448e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-0ae8-71ea-b357-5f53379354c7.webp",
      "image_media": {
        "alt_text": "Cozy apartment living area with a desk, chair, and daybed adorned with colorful pillows.",
        "public_id": "019d08aa-0ae8-71ea-b357-5f53379354c7",
        "storage_key": "property/6767906449166881/019d08aa-0ae8-71ea-b357-5f53379354c7.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "This versatile living space features a comfortable daybed with ample storage, a functional desk area, and stylish decor, perfect for relaxation or work.",
      "link": "false",
      "alt_text": "Cozy apartment living area with a desk, chair, and daybed adorned with colorful pillows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_Model2ndBedroom.jpg"
    },
    {
      "id": "ec_bd04c49c6bebf64560f4c242",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-1475-75eb-b602-1d7689f56452.webp",
      "image_media": {
        "alt_text": "Interior view of a bedroom closet with sliding doors and a ladder shelf.",
        "public_id": "019d08aa-1475-75eb-b602-1d7689f56452",
        "storage_key": "property/6767906449166881/019d08aa-1475-75eb-b602-1d7689f56452.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "Spacious closet with sliding doors, perfect for storage. Features a decorative ladder shelf with books and decor.",
      "link": "false",
      "alt_text": "Interior view of a bedroom closet with sliding doors and a ladder shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_Model2ndBedroomCloset.jpg"
    },
    {
      "id": "ec_8775053a39f7b7486478735c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-17c1-7128-ac2f-762ab11bc8ec.webp",
      "image_media": {
        "alt_text": "Washer and dryer with cleaning supplies in a hallway",
        "public_id": "019d08aa-17c1-7128-ac2f-762ab11bc8ec",
        "storage_key": "property/6767906449166881/019d08aa-17c1-7128-ac2f-762ab11bc8ec.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with convenient storage cabinets and cleaning supplies.",
      "link": "false",
      "alt_text": "Washer and dryer with cleaning supplies in a hallway",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelHallwayLaundry.jpg"
    },
    {
      "id": "ec_0bb4e4a56b0264db6abd061a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-177b-75df-b7fe-74c9e2c448f9.webp",
      "image_media": {
        "alt_text": "Bathroom with a toilet, bathtub with shower curtain, and vanity.",
        "public_id": "019d08aa-177b-75df-b7fe-74c9e2c448f9",
        "storage_key": "property/6767906449166881/019d08aa-177b-75df-b7fe-74c9e2c448f9.webp",
        "width": 732,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Relax and unwind in the well-appointed bathroom, featuring a bathtub, shower, and vanity with ample counter space.",
      "link": "false",
      "alt_text": "Bathroom with a toilet, bathtub with shower curtain, and vanity.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ModelUpgradedBathroom.jpg"
    },
    {
      "id": "ec_28740bffb1b6eaa2000e150c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-25c0-735a-9c10-8ba0d5c46a9c.webp",
      "image_media": {
        "alt_text": "Entrance to Sir Charles Court Apartments with decorative chains and hanging flowers.",
        "public_id": "019d08aa-25c0-735a-9c10-8ba0d5c46a9c",
        "storage_key": "property/6767906449166881/019d08aa-25c0-735a-9c10-8ba0d5c46a9c.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Welcome to Sir Charles Court Apartments, featuring a charming entrance with stone accents, lush greenery, and vibrant hanging flower baskets.",
      "link": "false",
      "alt_text": "Entrance to Sir Charles Court Apartments with decorative chains and hanging flowers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ClubhouseExterior.jpg"
    },
    {
      "id": "ec_94ef9272074e468a5931fe0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-2745-73a9-9f88-f52467e4b232.webp",
      "image_media": {
        "alt_text": "Manicured landscaping with a water fountain and a building in the background.",
        "public_id": "019d08aa-2745-73a9-9f88-f52467e4b232",
        "storage_key": "property/6767906449166881/019d08aa-2745-73a9-9f88-f52467e4b232.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Enjoy the serene ambiance of our property with beautiful landscaping, a tranquil water fountain, and inviting outdoor spaces.",
      "link": "false",
      "alt_text": "Manicured landscaping with a water fountain and a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_Fountain(1).jpg"
    },
    {
      "id": "ec_2518cf1495b9f7a36f0d83cc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-2891-73ca-baa3-ae6e7ec9731b.webp",
      "image_media": {
        "alt_text": "Community entrance area with two tables and chairs, community map display, and coffee station.",
        "public_id": "019d08aa-2891-73ca-baa3-ae6e7ec9731b",
        "storage_key": "property/6767906449166881/019d08aa-2891-73ca-baa3-ae6e7ec9731b.webp",
        "width": 2050,
        "height": 1469
      },
      "title": "Community",
      "description": "Welcome to the spacious and modern community entrance, featuring comfortable seating areas, a community map, and a convenient coffee station. Perfect for greeting guests or residents.",
      "link": "false",
      "alt_text": "Community entrance area with two tables and chairs, community map display, and coffee station.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ClubhouseFoyer.jpg"
    },
    {
      "id": "ec_3e86e6281b661b552db1178e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-2e19-7280-b413-28f6fdb7acb1.webp",
      "image_media": {
        "alt_text": "Cozy lounge area with a fireplace, comfortable seating, and large windows.",
        "public_id": "019d08aa-2e19-7280-b413-28f6fdb7acb1",
        "storage_key": "property/6767906449166881/019d08aa-2e19-7280-b413-28f6fdb7acb1.webp",
        "width": 2060,
        "height": 1470
      },
      "title": "Community",
      "description": "Relax by the warm fireplace in our inviting community lounge, featuring comfortable seating and ample natural light.",
      "link": "false",
      "alt_text": "Cozy lounge area with a fireplace, comfortable seating, and large windows.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ClubhouseFireplaceLounge.jpg"
    },
    {
      "id": "ec_2d79c2c7ca5ca27fa405568e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-4e71-758c-9fc7-800af841bcbb.webp",
      "image_media": {
        "alt_text": "Lounge area with a large sectional sofa, ottoman, and fireplace.",
        "public_id": "019d08aa-4e71-758c-9fc7-800af841bcbb",
        "storage_key": "property/6767906449166881/019d08aa-4e71-758c-9fc7-800af841bcbb.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our stylish community lounge, featuring comfortable seating, a cozy fireplace, and modern decor.",
      "link": "false",
      "alt_text": "Lounge area with a large sectional sofa, ottoman, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ClubhouseLounge01.jpg"
    },
    {
      "id": "ec_087050b6edae23922799246c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-4e95-7708-9d68-88ce64d44a20.webp",
      "image_media": {
        "alt_text": "Spacious lounge with a fireplace, comfortable seating, and a bar area.",
        "public_id": "019d08aa-4e95-7708-9d68-88ce64d44a20",
        "storage_key": "property/6767906449166881/019d08aa-4e95-7708-9d68-88ce64d44a20.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a cozy fireplace and ample seating.",
      "link": "false",
      "alt_text": "Spacious lounge with a fireplace, comfortable seating, and a bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ClubhouseLounge02.jpg"
    },
    {
      "id": "ec_e42be87e48d6a462c423ee0f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-3fea-7448-9377-3d6546d9a56c.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "019d08aa-3fea-7448-9377-3d6546d9a56c",
        "storage_key": "property/6767906449166881/019d08aa-3fea-7448-9377-3d6546d9a56c.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Utilize our convenient business center, equipped with computers and comfortable seating, perfect for getting work done.",
      "link": "false",
      "alt_text": "Business center with computers and seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_BusinessCenter.jpg"
    },
    {
      "id": "ec_0ab6afad30c26474480ab2f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-40f9-753c-b3b6-17aa34f5dc7f.webp",
      "image_media": {
        "alt_text": "Billiards table in a game room.",
        "public_id": "019d08aa-40f9-753c-b3b6-17aa34f5dc7f",
        "storage_key": "property/6767906449166881/019d08aa-40f9-753c-b3b6-17aa34f5dc7f.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our community game room, perfect for unwinding after a long day.",
      "link": "false",
      "alt_text": "Billiards table in a game room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_BilliardsRoom.jpg"
    },
    {
      "id": "ec_75aa3c51407d2314c4dd6358",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-649d-72d6-8081-60b3924937d3.webp",
      "image_media": {
        "alt_text": "Gym with weight machines and treadmills.",
        "public_id": "019d08aa-649d-72d6-8081-60b3924937d3",
        "storage_key": "property/6767906449166881/019d08aa-649d-72d6-8081-60b3924937d3.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "A well-equipped fitness center featuring various weight machines and cardio equipment for residents.",
      "link": "false",
      "alt_text": "Gym with weight machines and treadmills.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_FitnessCenter01.jpg"
    },
    {
      "id": "ec_f9b6b9a82b2b8143498bbf40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-5bb3-7216-90cf-21085b34d5ce.webp",
      "image_media": {
        "alt_text": "Interior of a gym with weight machines and mirrors, large windows overlook greenery.",
        "public_id": "019d08aa-5bb3-7216-90cf-21085b34d5ce",
        "storage_key": "property/6767906449166881/019d08aa-5bb3-7216-90cf-21085b34d5ce.webp",
        "width": 3072,
        "height": 2270
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring a variety of weight machines and cardio equipment. Perfect for your daily workout routine.",
      "link": "false",
      "alt_text": "Interior of a gym with weight machines and mirrors, large windows overlook greenery.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_FitnessCenter02.jpg"
    },
    {
      "id": "ec_6164df3dd2bbcf12973c720f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-6fbc-756d-a931-1eaf8963752a.webp",
      "image_media": {
        "alt_text": "Indoor hot tub with wooden ceiling and tiled walls.",
        "public_id": "019d08aa-6fbc-756d-a931-1eaf8963752a",
        "storage_key": "property/6767906449166881/019d08aa-6fbc-756d-a931-1eaf8963752a.webp",
        "width": 1024,
        "height": 732
      },
      "title": "Community",
      "description": "Relax and unwind in the community hot tub, a perfect amenity for year-round enjoyment.",
      "link": "false",
      "alt_text": "Indoor hot tub with wooden ceiling and tiled walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_IndoorSpa.jpg"
    },
    {
      "id": "ec_85aa76ab6f736322fb10d153",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-76cb-7054-8f52-3a88025c525d.webp",
      "image_media": {
        "alt_text": "Sparkling outdoor swimming pool with lounge chairs and apartment buildings in the background.",
        "public_id": "019d08aa-76cb-7054-8f52-3a88025c525d",
        "storage_key": "property/6767906449166881/019d08aa-76cb-7054-8f52-3a88025c525d.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by lush greenery and comfortable lounge chairs. Perfect for relaxing on a sunny day.",
      "link": "false",
      "alt_text": "Sparkling outdoor swimming pool with lounge chairs and apartment buildings in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_SwimmingPool.jpg"
    },
    {
      "id": "ec_131a567b4541feeaf7cce35d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-7d2f-7109-8294-778165234462.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
        "public_id": "019d08aa-7d2f-7109-8294-778165234462",
        "storage_key": "property/6767906449166881/019d08aa-7d2f-7109-8294-778165234462.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs for sunbathing and unwinding.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_PoolDeckLounges.jpg"
    },
    {
      "id": "ec_e97ebbd614978323a8448096",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-83eb-70fe-9d5b-8259242a87bb.webp",
      "image_media": {
        "alt_text": "Swimming pool and apartment buildings",
        "public_id": "019d08aa-83eb-70fe-9d5b-8259242a87bb",
        "storage_key": "property/6767906449166881/019d08aa-83eb-70fe-9d5b-8259242a87bb.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush landscaping and comfortable seating areas. An ideal spot for relaxation and recreation.",
      "link": "false",
      "alt_text": "Swimming pool and apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_SwimmingPoolBuildingExteriors.jpg"
    },
    {
      "id": "ec_4506bf6a2d012a98ba4c11ed",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-8fef-72b9-9a3f-3494e6b7d0b6.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
        "public_id": "019d08aa-8fef-72b9-9a3f-3494e6b7d0b6",
        "storage_key": "property/6767906449166881/019d08aa-8fef-72b9-9a3f-3494e6b7d0b6.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, surrounded by lush landscaping and comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Outdoor swimming pool with lounge chairs and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_SwimmingPoolClubhouseExterior.jpg"
    },
    {
      "id": "ec_7c981f97bffd5151470a11f9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-9722-705f-a010-4f736e61aef9.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and built-in grill area with lounge chairs, next to apartment buildings.",
        "public_id": "019d08aa-9722-705f-a010-4f736e61aef9",
        "storage_key": "property/6767906449166881/019d08aa-9722-705f-a010-4f736e61aef9.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling outdoor swimming pool, or grill up a feast at the community BBQ area. Relax in the sun in comfortable lounge chairs.",
      "link": "false",
      "alt_text": "Outdoor swimming pool and built-in grill area with lounge chairs, next to apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_WadingPool(1).jpg"
    },
    {
      "id": "ec_820c52ea3a3accc3afe33d4f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-a165-7660-99fb-d2e6ad7e56a7.webp",
      "image_media": {
        "alt_text": "Amazon Hub package lockers with digital interface and keypad.",
        "public_id": "019d08aa-a165-7660-99fb-d2e6ad7e56a7",
        "storage_key": "property/6767906449166881/019d08aa-a165-7660-99fb-d2e6ad7e56a7.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure package lockers available for residents' convenience, featuring the Amazon Hub service for easy package delivery and retrieval.",
      "link": "false",
      "alt_text": "Amazon Hub package lockers with digital interface and keypad.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_SelfServicePackageLockers.jpg"
    },
    {
      "id": "ec_87679a5932c5d4c3c9a48930",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-9c6d-7362-83c9-95741016c472.webp",
      "image_media": {
        "alt_text": "Mailboxes lined up under a covered structure at a multifamily property.",
        "public_id": "019d08aa-9c6d-7362-83c9-95741016c472",
        "storage_key": "property/6767906449166881/019d08aa-9c6d-7362-83c9-95741016c472.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Convenient mail delivery is available for residents with these organized mailboxes located under a covered shelter.",
      "link": "false",
      "alt_text": "Mailboxes lined up under a covered structure at a multifamily property.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_MailStation.jpg"
    },
    {
      "id": "ec_4dbba988d3278645b81c23d2",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b0b6-77df-8d72-6432de799ff4.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019d08aa-b0b6-77df-8d72-6432de799ff4",
        "storage_key": "property/6767906449166881/019d08aa-b0b6-77df-8d72-6432de799ff4.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring slides and climbing structures for all ages.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structures.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_Playground.jpg"
    },
    {
      "id": "ec_a4f407426a59722e23dc5bdc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b49f-748e-8560-ff1eee6bb8ef.webp",
      "image_media": {
        "alt_text": "Basketball court and apartment building exterior with trees and blue sky.",
        "public_id": "019d08aa-b49f-748e-8560-ff1eee6bb8ef",
        "storage_key": "property/6767906449166881/019d08aa-b49f-748e-8560-ff1eee6bb8ef.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Enjoy outdoor recreation at the basketball court, surrounded by lush greenery and the charming apartment buildings.",
      "link": "false",
      "alt_text": "Basketball court and apartment building exterior with trees and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_BasketballCourt.jpg"
    },
    {
      "id": "ec_4e3dd272f9c5f2410a3c3ac1",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-b915-7735-a0ea-c4d20b9414fa.webp",
      "image_media": {
        "alt_text": "Covered parking spaces with cars in front of apartment buildings.",
        "public_id": "019d08aa-b915-7735-a0ea-c4d20b9414fa",
        "storage_key": "property/6767906449166881/019d08aa-b915-7735-a0ea-c4d20b9414fa.webp",
        "width": 2048,
        "height": 1367
      },
      "title": "Community",
      "description": "Covered parking spaces provide convenient and protected parking for residents at this apartment community.",
      "link": "false",
      "alt_text": "Covered parking spaces with cars in front of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ThreeStoryBuildingCarports.jpg"
    },
    {
      "id": "ec_80326f695fa7036b7bd0ab20",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-c69e-75b9-a617-f8c27db1fffe.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and blue sky.",
        "public_id": "019d08aa-c69e-75b9-a617-f8c27db1fffe",
        "storage_key": "property/6767906449166881/019d08aa-c69e-75b9-a617-f8c27db1fffe.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming apartment building exteriors with lush green lawns and clear blue skies, offering a welcoming community atmosphere.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_TwoStoryBuildingWalkingPath.jpg"
    },
    {
      "id": "ec_f2e656bea2a89172717f2286",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-ceff-75db-8a61-ab96d79e21d0.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
        "public_id": "019d08aa-ceff-75db-8a61-ab96d79e21d0",
        "storage_key": "property/6767906449166881/019d08aa-ceff-75db-8a61-ab96d79e21d0.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Beautifully maintained apartment exteriors surrounded by lush green lawns and mature trees, offering a serene living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_TwoStoryBuildingEntry.jpg"
    },
    {
      "id": "ec_cfb7064672870ad185312622",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-d1d1-7721-ae7d-c36447844c73.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with green lawn and trees.",
        "public_id": "019d08aa-d1d1-7721-ae7d-c36447844c73",
        "storage_key": "property/6767906449166881/019d08aa-d1d1-7721-ae7d-c36447844c73.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring well-maintained landscaping and ample green space.",
      "link": "false",
      "alt_text": "Exterior of apartment building with green lawn and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_TwoStoryBuildingParkingLot.jpg"
    },
    {
      "id": "ec_1dda743350a82b2f09fd60fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-d1e3-7593-9351-1da572c9d0cd.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with manicured lawns and trees under a blue sky.",
        "public_id": "019d08aa-d1e3-7593-9351-1da572c9d0cd",
        "storage_key": "property/6767906449166881/019d08aa-d1e3-7593-9351-1da572c9d0cd.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Welcome home to this beautiful apartment complex, featuring well-maintained exteriors and lush green spaces for a peaceful living environment.",
      "link": "false",
      "alt_text": "Exterior view of apartment buildings with manicured lawns and trees under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_ThreeStoryBuildingExterior(1).jpg"
    },
    {
      "id": "ec_0c104220a15f936cebeb3be9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08aa-e66f-7728-bb10-9448c45ad2cc.webp",
      "image_media": {
        "alt_text": "Row of garage doors in a multifamily property parking lot.",
        "public_id": "019d08aa-e66f-7728-bb10-9448c45ad2cc",
        "storage_key": "property/6767906449166881/019d08aa-e66f-7728-bb10-9448c45ad2cc.webp",
        "width": 2048,
        "height": 1463
      },
      "title": "Community",
      "description": "Secure and convenient garage parking available for residents at this multifamily property.",
      "link": "false",
      "alt_text": "Row of garage doors in a multifamily property parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/93313/SirCharlesCourt_Beaverton_OR_Garages.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "ec_768f7b04ceb4ea19bd73de64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "BGs Food Cartel",
      "poi_type": "Restaurants",
      "poi_address": "4250 SW Rose Biggi Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "Open-air space with over 30 international food trucks, plus an indoor/outdoor speakeasy-style bar.",
      "poi_long_description": "Open-air space with over 30 international food trucks, plus an indoor/outdoor speakeasy-style bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-b5ef-7469-b389-66f1701ebefd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b5ef-7469-b389-66f1701ebefd",
        "storage_key": "property/6767906449166881/019d08ab-b5ef-7469-b389-66f1701ebefd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://bgfoodcartel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13359900484536572783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bgs-food-cartel",
      "poi_latitude": "45.4892645",
      "poi_longitude": "-122.8081145",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-605-9163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJJSQIYZ8OlVQRbxtf97TmZ7k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_873a43ae999594c556cf968e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Bethany Public House",
      "poi_type": "Restaurants",
      "poi_address": "4840 NW Bethany Blvd, Portland, OR 97229, USA",
      "poi_short_description": "Chill, family-friendly gastropub offering eclectic comfort food, craft brews on tap & patio seating.",
      "poi_long_description": "Chill, family-friendly gastropub offering eclectic comfort food, craft brews on tap & patio seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-b5ee-720b-8c9d-980a9d6614d2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b5ee-720b-8c9d-980a9d6614d2",
        "storage_key": "property/6767906449166881/019d08ab-b5ee-720b-8c9d-980a9d6614d2.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://www.bethanypublichouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9645659060353319411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bethany-public-house",
      "poi_latitude": "45.5556047",
      "poi_longitude": "-122.8346608",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 971-371-2954",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-573d-74a9-bf10-83c8f84bbe1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-573d-74a9-bf10-83c8f84bbe1f",
        "storage_key": "property/6767906449166881/019d08ac-573d-74a9-bf10-83c8f84bbe1f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWjz1KUIlVQR80HjfM9D3IU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "ec_355d0f516905f5f54ec9d6db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "McMenamins Cornelius Pass Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "4045 NE Cornelius Pass Rd, Hillsboro, OR 97124, USA",
      "poi_short_description": "Brewery, distillery & pub & separate cigar bar in the McMenamins chain on an 1850 former farmstead.",
      "poi_long_description": "Brewery, distillery & pub & separate cigar bar in the McMenamins chain on an 1850 former farmstead.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-b7c3-72e8-bfe5-2cbd27c5289a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b7c3-72e8-bfe5-2cbd27c5289a",
        "storage_key": "property/6767906449166881/019d08ab-b7c3-72e8-bfe5-2cbd27c5289a.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.mcmenamins.com/cornelius-pass-roadhouse?utm_source=Google%20Maps&utm_medium=Website%20Button&utm_campaign=CPR",
      "poi_directions_map_url": "https://maps.google.com/?cid=12927787394836365711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcmenamins-cornelius-pass-roadhouse",
      "poi_latitude": "45.54910539999999",
      "poi_longitude": "-122.9010141",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 28 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-640-6174",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-573d-74a9-bf10-83c8f84bbe1f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-573d-74a9-bf10-83c8f84bbe1f",
        "storage_key": "property/6767906449166881/019d08ac-573d-74a9-bf10-83c8f84bbe1f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjVhfwI8FlVQRj4H-KCS6aLM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pub"
    },
    {
      "id": "ec_3c8691712955c1adc142675b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "The Streets of Tanasbourne",
      "poi_type": "Restaurants",
      "poi_address": "10050 NW Emma Way, Hillsboro, OR 97124, USA",
      "poi_short_description": "Expansive shopping center with brand-name stores & restaurants with outdoor seating near a fountain.",
      "poi_long_description": "Expansive shopping center with brand-name stores & restaurants with outdoor seating near a fountain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-b628-720f-81e2-ebbdb5a7a27c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-b628-720f-81e2-ebbdb5a7a27c",
        "storage_key": "property/6767906449166881/019d08ab-b628-720f-81e2-ebbdb5a7a27c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.streetsoftanasbourne.com/?utm_source=google-business-profile&utm_medium=organic&utm_campaign=business-listing&utm_id=3403",
      "poi_directions_map_url": "https://maps.google.com/?cid=13922127728717791092&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-streets-of-tanasbourne",
      "poi_latitude": "45.53709689999999",
      "poi_longitude": "-122.878719",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-533-0561",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNRhYW28PlVQRdP_WG2hVNcE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_9b95b51e72afb7cca28b9da3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Thirsty Lion",
      "poi_type": "Restaurants",
      "poi_address": "2290 NE Allie Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "Scratch-kitchen restaurant offering a large variety of globally inspired food, plus craft cocktails.",
      "poi_long_description": "Scratch-kitchen restaurant offering a large variety of globally inspired food, plus craft cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-bed8-7007-aa27-bed65d76dedd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-bed8-7007-aa27-bed65d76dedd",
        "storage_key": "property/6767906449166881/019d08ab-bed8-7007-aa27-bed65d76dedd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thirstylionrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7890111086997040471&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thirsty-lion",
      "poi_latitude": "45.5365158",
      "poi_longitude": "-122.8769515",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-336-0403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0yjDpWgPlVQRV23U4jpOf20",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "ec_c564e920a389bd6ba4f4d92e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "P.F. Chang's",
      "poi_type": "Restaurants",
      "poi_address": "10088 NW Emma Way, Hillsboro, OR 97124, USA",
      "poi_short_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_long_description": "Family-friendly chain offering creative takes on Asian fare in a striking space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-beff-704f-a672-2bcf46c4958d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-beff-704f-a672-2bcf46c4958d",
        "storage_key": "property/6767906449166881/019d08ab-beff-704f-a672-2bcf46c4958d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.pfchangs.com/or/hillsboro/10088-ne-emma-way.html?utm_source=google_gbp&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=8250878714872756242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pf-changs",
      "poi_latitude": "45.53507",
      "poi_longitude": "-122.8779978",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-533-4580",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJL9tH_2UPlVQREnjS5HkCgXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "ec_1653a802cbd4bf3a8a1a09b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Corner Bakery Cafe",
      "poi_type": "Restaurants",
      "poi_address": "19325 NW Emma Way Ste 1210, Hillsboro, OR 97124, USA",
      "poi_short_description": "Casual, counter-serve cafe chain offering a standard menu of sandwiches, pasta & pastries.",
      "poi_long_description": "Casual, counter-serve cafe chain offering a standard menu of sandwiches, pasta & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-bf33-7631-b52c-fe66060c12b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-bf33-7631-b52c-fe66060c12b4",
        "storage_key": "property/6767906449166881/019d08ab-bf33-7631-b52c-fe66060c12b4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cornerbakerycafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7054962751396801297&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corner-bakery-cafe",
      "poi_latitude": "45.5355834",
      "poi_longitude": "-122.8776013",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-536-2375",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d8-734e-a41a-cd0c11681d61.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d8-734e-a41a-cd0c11681d61",
        "storage_key": "property/6767906449166881/019d08ac-56d8-734e-a41a-cd0c11681d61.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJOTNXW28PlVQREWueXD5D6GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "ec_304ed76f4d64443095efd705",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Great Harvest Bread Co., Hillsboro",
      "poi_type": "Restaurants",
      "poi_address": "2105 NW 185th Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "Bakery chain specializing in whole-grain breads & muffins made with Montana wheat.",
      "poi_long_description": "Bakery chain specializing in whole-grain breads & muffins made with Montana wheat.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-c005-7260-815b-a2bdf8de615a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c005-7260-815b-a2bdf8de615a",
        "storage_key": "property/6767906449166881/019d08ab-c005-7260-815b-a2bdf8de615a.webp",
        "width": 720,
        "height": 960
      },
      "poi_business_url": "http://www.greatharvesthillsboro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7522847274111391084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-harvest-bread-co-hillsboro",
      "poi_latitude": "45.5353632",
      "poi_longitude": "-122.8701751",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-466-1112",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJOUe4v2kPlVQRbNXs8LyFZmg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "ec_0b1b4758f8140f46ae85b627",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Schmizza Public House",
      "poi_type": "Restaurants",
      "poi_address": "998 NE Orenco Station Pkwy, Hillsboro, OR 97124, USA",
      "poi_short_description": "Casual restaurant pizzeria featuring burgers, pizzas and other fare, plus craft beer on tap, wine and cocktails.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-c68c-728d-b9d2-c2ace85a4f02.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-c68c-728d-b9d2-c2ace85a4f02",
        "storage_key": "property/6767906449166881/019d08ab-c68c-728d-b9d2-c2ace85a4f02.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "http://schmizzapublichouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8202805215658207953&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "schmizza-public-house",
      "poi_latitude": "45.5312522",
      "poi_longitude": "-122.9166054",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-718-7120",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMZ_CJoYPlVQR0WoHIeI31nE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_8df803d2164937994e37b659",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "WildFin American Grill - Beaverton",
      "poi_type": "Restaurants",
      "poi_address": "2725 SW Cedar Hills Blvd #130, Beaverton, OR 97005, USA",
      "poi_short_description": "Casual, seafood-focused eatery serving burgers, grilled fishes, seafood chowder and seafood pastas.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-cbdc-75ef-8982-2cd82fdc7c16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cbdc-75ef-8982-2cd82fdc7c16",
        "storage_key": "property/6767906449166881/019d08ab-cbdc-75ef-8982-2cd82fdc7c16.webp",
        "width": 1200,
        "height": 799
      },
      "poi_business_url": "https://www.wildfinamericangrill.com/beaverton/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17648912832637524328&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wildfin-american-grill---beaverton",
      "poi_latitude": "45.4999988",
      "poi_longitude": "-122.8086187",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-718-7331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYR45BRwPlVQRaFkxnbaI7fQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "ec_28e2049064b82019afefdeb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Bellagios Pizza",
      "poi_type": "Restaurants",
      "poi_address": "16265 NW Cornell Rd #101, Beaverton, OR 97006, USA",
      "poi_short_description": "Branch of a local chain offering specialty & build-your-own pies, plus grinders & calzones.",
      "poi_long_description": "Branch of a local chain offering specialty & build-your-own pies, plus grinders & calzones.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-cb63-73fe-834a-fba165a492ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cb63-73fe-834a-fba165a492ce",
        "storage_key": "property/6767906449166881/019d08ab-cb63-73fe-834a-fba165a492ce.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.bellagiospizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8592164570528860687&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bellagios-pizza",
      "poi_latitude": "45.530631",
      "poi_longitude": "-122.844149",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-466-2070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgeyuDzoPlVQRD8oRVieAPXc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "ec_5868bb164a48694c2a80235a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Krispy Kreme",
      "poi_type": "Restaurants",
      "poi_address": "16415 NW Cornell Rd, Beaverton, OR 97006, USA",
      "poi_short_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_long_description": "Longtime chain serving a variety of donut flavors & shapes, plus coffee & frozen drinks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-cada-774c-a6db-be755cdbbde5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cada-774c-a6db-be755cdbbde5",
        "storage_key": "property/6767906449166881/019d08ab-cada-774c-a6db-be755cdbbde5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://site.krispykreme.com/or/beaverton/16415-nw-cornell-rd?y_source=1_MTE4OTc4NDQtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12007366191941839472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krispy-kreme",
      "poi_latitude": "45.5332639",
      "poi_longitude": "-122.8469891",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 503-645-2228",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56d9-744f-82cd-280a191e6e9e",
        "storage_key": "property/6767906449166881/019d08ac-56d9-744f-82cd-280a191e6e9e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm9Qo1jkPlVQRcGq6Du-7oqY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "donut_shop"
    },
    {
      "id": "ec_aa61084196c587df5da10331",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "New Seasons Market - Tanasbourne",
      "poi_type": "Shopping & Retail",
      "poi_address": "10940 NE Evergreen Pkwy, Hillsboro, OR 97006, USA",
      "poi_short_description": "This grocery supplier with many locally sourced items also sells home goods & wellness products.",
      "poi_long_description": "This grocery supplier with many locally sourced items also sells home goods & wellness products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-cfa5-7175-b75b-70bb9c73ad7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-cfa5-7175-b75b-70bb9c73ad7a",
        "storage_key": "property/6767906449166881/019d08ab-cfa5-7175-b75b-70bb9c73ad7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.newseasonsmarket.com/find-a-store/tanasbourne",
      "poi_directions_map_url": "https://maps.google.com/?cid=18064387823385485489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-seasons-market---tanasbourne",
      "poi_latitude": "45.537262",
      "poi_longitude": "-122.8655931",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 971-732-7835",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eae-74c5-84a0-83d31e8ec884",
        "storage_key": "property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG6N_AAAPlVQRsaDIIQSZsfo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_c7915022f81cd9bc12ad8cf2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "11095 NE Evergreen Pkwy, Hillsboro, OR 97006, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-d49e-7346-be45-5f81cdc228b6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d49e-7346-be45-5f81cdc228b6",
        "storage_key": "property/6767906449166881/019d08ab-d49e-7346-be45-5f81cdc228b6.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tanasbourne/910",
      "poi_directions_map_url": "https://maps.google.com/?cid=1335167351497914166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "45.5393735",
      "poi_longitude": "-122.8640919",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-531-3656",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7ehxbkMPlVQRNne71aF3hxI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2cd7a1e461c2a0b9208713e1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "17275 NW Cornell Rd, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-d4bd-77a8-8cde-7a617e1596b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d4bd-77a8-8cde-7a617e1596b9",
        "storage_key": "property/6767906449166881/019d08ab-d4bd-77a8-8cde-7a617e1596b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/5993-beaverton-or/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7695010578633667457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "45.5354549",
      "poi_longitude": "-122.8525762",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-207-7627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eae-74c5-84a0-83d31e8ec884",
        "storage_key": "property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbikl0cPlVQRgTNV8lkrymo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_a868405d48c5023911e2b3c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "18101 NW Evergreen Pkwy, Beaverton, OR 97006, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-d4a1-73ed-91a0-be77c2278ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d4a1-73ed-91a0-be77c2278ddc",
        "storage_key": "property/6767906449166881/019d08ab-d4a1-73ed-91a0-be77c2278ddc.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/beaverton-or-pharmacies/18101-nw-evergreen-pkwy-beaverton-or-97006/storeid=16336?WT.mc_id=LS_GOOGLE_RX_16336",
      "poi_directions_map_url": "https://maps.google.com/?cid=4428783883877281184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "45.5394315",
      "poi_longitude": "-122.8643345",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-207-0041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eae-74c5-84a0-84db33932e5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eae-74c5-84a0-84db33932e5b",
        "storage_key": "property/6767906449166881/019d08ac-5eae-74c5-84a0-84db33932e5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ehxbkMPlVQRoO16SXozdj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_7bfec60c5765c6ee953fed59",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "99 Ranch Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "8155 SW Hall Blvd, Beaverton, OR 97008, USA",
      "poi_short_description": "Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.",
      "poi_long_description": "Asian supermarket chain carrying imported specialty foods plus meat, seafood, produce & baked goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-d838-73ce-a745-def0ca4b52c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d838-73ce-a745-def0ca4b52c7",
        "storage_key": "property/6767906449166881/019d08ab-d838-73ce-a745-def0ca4b52c7.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "http://99ranch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16482590746551729438&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "99-ranch-market",
      "poi_latitude": "45.4602283",
      "poi_longitude": "-122.7966848",
      "poi_miles_from_property": "7.1 mi",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-605-1899",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eae-74c5-84a0-83d31e8ec884",
        "storage_key": "property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqROpYk4MlVQRHj1bmvTsveQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_3648cc1f7894a40876c96c30",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "11115 NE Evergreen Pkwy, Hillsboro, OR 97006, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-dd74-737e-a881-2d68eec71713.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-dd74-737e-a881-2d68eec71713",
        "storage_key": "property/6767906449166881/019d08ab-dd74-737e-a881-2d68eec71713.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.bestbuy.com/or/hillsboro/11115-ne-evergreen-pkwy-1491.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=6648605481353283218&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "45.538973",
      "poi_longitude": "-122.8629027",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-645-6061",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJPWmaeEMPlVQRkgbHn3WXRFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "ec_afcfd1719e65810c4244857d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Nordstrom Rack",
      "poi_type": "Shopping & Retail",
      "poi_address": "11100 NE Evergreen Pkwy, Hillsboro, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-dd43-701c-9d05-29bb90d2e497.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-dd43-701c-9d05-29bb90d2e497",
        "storage_key": "property/6767906449166881/019d08ab-dd43-701c-9d05-29bb90d2e497.webp",
        "width": 640,
        "height": 340
      },
      "poi_business_url": "https://stores.nordstromrack.com/us/or/hillsboro/11100-ne-evergreen-pkwy?utm_source=google&utm_medium=organic&utm_campaign=rack&utm_content=27&utm_channel=low_nd_seo_local&sp_source=google&sp_campaign=rack",
      "poi_directions_map_url": "https://maps.google.com/?cid=14699991625292485289&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nordstrom-rack",
      "poi_latitude": "45.5354909",
      "poi_longitude": "-122.8655952",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-439-0900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJn4lKHkIPlVQRqZLG0n_cAMw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "ec_2a345be6ec5c761dc897ad86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Ross Dress for Less",
      "poi_type": "Shopping & Retail",
      "poi_address": "18057 NW Evergreen Pkwy, Beaverton, OR 97006, USA",
      "poi_short_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_long_description": "Retail chain selling brand-name clothing, shoes, accessories & housewares at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-de1e-754a-b900-7a3d08de8143.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-de1e-754a-b900-7a3d08de8143",
        "storage_key": "property/6767906449166881/019d08ab-de1e-754a-b900-7a3d08de8143.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.rossstores.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6588443330251490553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ross-dress-for-less",
      "poi_latitude": "45.5383563",
      "poi_longitude": "-122.8612487",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-690-8166",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJYfDXxEMPlVQR-YRuQk3abls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "ec_17e33a64aaaa8aca681db565",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "7-Eleven",
      "poi_type": "Shopping & Retail",
      "poi_address": "75 NW 158th Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_long_description": "Pit stop for snacks, drinks & daily essentials",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-e1ae-75ca-9225-edfeebdb1709.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e1ae-75ca-9225-edfeebdb1709",
        "storage_key": "property/6767906449166881/019d08ab-e1ae-75ca-9225-edfeebdb1709.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.7-eleven.com/locations/or/beaverton/75-nw-158th-st-35335?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=4450278396647817884&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "7-eleven",
      "poi_latitude": "45.5203389",
      "poi_longitude": "-122.8404043",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-439-0013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eb5-718a-aa8a-e16fc7d83697.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eb5-718a-aa8a-e16fc7d83697",
        "storage_key": "property/6767906449166881/019d08ac-5eb5-718a-aa8a-e16fc7d83697.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJ9xFALCEPlVQRnMLJh5-Qwj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "ec_b6022cc71431fa02a4266da4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Tanasbourne Town Center",
      "poi_type": "Shopping & Retail",
      "poi_address": "11000 NE Evergreen Pkwy, Hillsboro, OR 97006, USA",
      "poi_short_description": "Shopping mall featuring a variety of shops, some eateries, ample parking, and good vibes.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-e591-71fc-874c-6e98a308b3f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e591-71fc-874c-6e98a308b3f3",
        "storage_key": "property/6767906449166881/019d08ab-e591-71fc-874c-6e98a308b3f3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.sitecenters.com/properties/tanasbourne-town-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14240138813639413708&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tanasbourne-town-center",
      "poi_latitude": "45.5373716",
      "poi_longitude": "-122.8636909",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbwpkmUMPlVQRzM86s80in8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "ec_f72313447b2b3e534da8cb4a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Oak Hills Elementary School",
      "poi_type": "Education",
      "poi_address": "2625 NW 153rd Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://oakhills.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8252120424168444921&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-hills-elementary-school",
      "poi_latitude": "45.5388863",
      "poi_longitude": "-122.8360763",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 503-356-2410",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJL3CoTjUPlVQR-VNO3s1rhXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a7cd17f081bb7d16419003c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Five Oaks Middle School",
      "poi_type": "Education",
      "poi_address": "1600 NW 173rd Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-e6f6-778e-aebc-f7577ac53956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e6f6-778e-aebc-f7577ac53956",
        "storage_key": "property/6767906449166881/019d08ab-e6f6-778e-aebc-f7577ac53956.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://fiveoaks.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9153893578572294336&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "five-oaks-middle-school",
      "poi_latitude": "45.53070719999999",
      "poi_longitude": "-122.8534502",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-356-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO2kgnD4PlVQRwOiH1rUpCX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "ec_c86956d6981cca0e92fa408c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Westview High School",
      "poi_type": "Education",
      "poi_address": "4200 NW 185th Ave, Portland, OR 97229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-e727-721e-92d8-5503b28cb151.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-e727-721e-92d8-5503b28cb151",
        "storage_key": "property/6767906449166881/019d08ab-e727-721e-92d8-5503b28cb151.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://westview.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8482233672057929382&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westview-high-school",
      "poi_latitude": "45.5511152",
      "poi_longitude": "-122.8653924",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-356-3020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy7QzuFcPlVQRpr7efJXytnU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_2e59aa8f570f129b62e7fb03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Aloha-Huber Park Elementary School",
      "poi_type": "Education",
      "poi_address": "5000 SW 173rd Ave, Beaverton, OR 97007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-ef2c-719d-a8ac-b0749477a876.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ef2c-719d-a8ac-b0749477a876",
        "storage_key": "property/6767906449166881/019d08ab-ef2c-719d-a8ac-b0749477a876.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://alohahuberpark.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15802722143136179482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aloha-huber-park-elementary-school",
      "poi_latitude": "45.483953",
      "poi_longitude": "-122.8538441",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 503-356-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJUUfRfWUOlVQRGuXUERCMTts",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_53b2c50849aade696fafb9f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Merlo Station High School",
      "poi_type": "Education",
      "poi_address": "97003, 1841 SW Merlo Dr, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://communityschool.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9531244063160347694&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merlo-station-high-school",
      "poi_latitude": "45.5061332",
      "poi_longitude": "-122.8481904",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-356-3650",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB46wM-UOlVQRLiw5DPrHRYQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_9ecbe24e0ca012e43141f8b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton Academy of Science & Engineering",
      "poi_type": "Education",
      "poi_address": "10740 NE Walker Rd, Hillsboro, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://base.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17118693406936757777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-academy-of-science--engineering",
      "poi_latitude": "45.5270786",
      "poi_longitude": "-122.8695172",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-356-3630",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB46wM-UOlVQREXZJc_TQke0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_ec1d9d663af3a059c146b566",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Faith Bible High School - Tanasbourne Campus",
      "poi_type": "Education",
      "poi_address": "8975 NE Walker Rd #120, Hillsboro, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-f3d7-70ce-b4b3-d627ba9e8517.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f3d7-70ce-b4b3-d627ba9e8517",
        "storage_key": "property/6767906449166881/019d08ab-f3d7-70ce-b4b3-d627ba9e8517.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.fbcs.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13028242968242771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "faith-bible-high-school---tanasbourne-campus",
      "poi_latitude": "45.536052",
      "poi_longitude": "-122.8873849",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 12 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-681-8254",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGTUWmH4PlVQRp1eX-fOdzbQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "ec_415892d29bb1083cfad2d1b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Little Stars Montessori",
      "poi_type": "Education",
      "poi_address": "3258 NW 185th Ave, Portland, OR 97229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-ef5f-76fd-9f5d-6cc604e906ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ef5f-76fd-9f5d-6cc604e906ff",
        "storage_key": "property/6767906449166881/019d08ab-ef5f-76fd-9f5d-6cc604e906ff.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.littlestars-montessori.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10367190222720321692&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "little-stars-montessori",
      "poi_latitude": "45.5434475",
      "poi_longitude": "-122.8658906",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-531-7930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzzbBwVsPlVQRnMglcJSo348",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "ec_9a5ad7901c30664243bad5a2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Portland Community College Rock Creek",
      "poi_type": "Education",
      "poi_address": "17705 NW Springville Rd, Portland, OR 97229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-f4f4-75be-a80c-fa72117dc014.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f4f4-75be-a80c-fa72117dc014",
        "storage_key": "property/6767906449166881/019d08ab-f4f4-75be-a80c-fa72117dc014.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.pcc.edu/about/locations/rock-creek/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3966148189600444475&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portland-community-college-rock-creek",
      "poi_latitude": "45.5668982",
      "poi_longitude": "-122.8604923",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 971-722-6111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzascJg8GlVQRO3Cxz8OWCjc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "ec_be36b535d09348a9ca0c2dde",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Errol Hassell Elementary School",
      "poi_type": "Education",
      "poi_address": "18100 SW Bany Rd, Beaverton, OR 97007, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-f8e2-7273-b4c3-b9d017fcb66d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f8e2-7273-b4c3-b9d017fcb66d",
        "storage_key": "property/6767906449166881/019d08ab-f8e2-7273-b4c3-b9d017fcb66d.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://errolhassell.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15389241532858887335&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "errol-hassell-elementary-school",
      "poi_latitude": "45.466584",
      "poi_longitude": "-122.863246",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 503-356-2090",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEwSka-INlVQRp-y9cKORkdU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "ec_a4761ace6e71b0d1530d2639",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "AMC Progress Ridge 13",
      "poi_type": "Entertainment",
      "poi_address": "12345 SW Horizon Blvd #231, Beaverton, OR 97007, USA",
      "poi_short_description": "Moviegoers can take food from the on-site eatery to their seats, with table service in 21+ theaters.",
      "poi_long_description": "Moviegoers can take food from the on-site eatery to their seats, with table service in 21+ theaters.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-f9cd-7614-850c-9ed456a69a5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-f9cd-7614-850c-9ed456a69a5d",
        "storage_key": "property/6767906449166881/019d08ab-f9cd-7614-850c-9ed456a69a5d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/seattle-tacoma/amc-progress-ridge-13?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=11755852546722219653&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-progress-ridge-13",
      "poi_latitude": "45.4305758",
      "poi_longitude": "-122.8316692",
      "poi_miles_from_property": "8.6 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 503-549-2293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e3-7777-bc04-b863fe7d53b9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e3-7777-bc04-b863fe7d53b9",
        "storage_key": "property/6767906449166881/019d08ac-64e3-7777-bc04-b863fe7d53b9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ2SL_XsNlVQRhcY_J5stJaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "ec_86c012dd7629d1bc170c5367",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Big Al's",
      "poi_type": "Entertainment",
      "poi_address": "14950 SW Barrows Rd, Beaverton, OR 97007, USA",
      "poi_short_description": "Big entertainment venue featuring a bowling alley, an arcade & a sports bar & grill with plasma TVs.",
      "poi_long_description": "Big entertainment venue featuring a bowling alley, an arcade & a sports bar & grill with plasma TVs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-ff19-7101-8565-e71bf50821cc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-ff19-7101-8565-e71bf50821cc",
        "storage_key": "property/6767906449166881/019d08ab-ff19-7101-8565-e71bf50821cc.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ilovebigals.com/beaverton/?utm_source=google&utm_medium=local-gmb&utm_campaign=beaverton",
      "poi_directions_map_url": "https://maps.google.com/?cid=17239944569558995133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "big-als",
      "poi_latitude": "45.4288125",
      "poi_longitude": "-122.8296344",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 13 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 503-748-6118",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC4jVhXsNlVQRvRD9rz6WQO8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_86c55c5ff41535607eeff16d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "KingPins Family Entertainment Center",
      "poi_type": "Entertainment",
      "poi_address": "2725 SW Cedar Hills Blvd, Beaverton, OR 97005, USA",
      "poi_short_description": "This sizable bowling alley with leagues also offers arcade games & an on-site bar & grill.",
      "poi_long_description": "This sizable bowling alley with leagues also offers arcade games & an on-site bar & grill.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-fed3-72aa-a690-ab8b929c9ee7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-fed3-72aa-a690-ab8b929c9ee7",
        "storage_key": "property/6767906449166881/019d08ab-fed3-72aa-a690-ab8b929c9ee7.webp",
        "width": 1280,
        "height": 480
      },
      "poi_business_url": "http://mykingpins.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10139395232758458330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kingpins-family-entertainment-center",
      "poi_latitude": "45.5003588",
      "poi_longitude": "-122.8094562",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 503-646-1116",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl3zpjLkOlVQR2mfbTT5etow",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "ec_84a8edb96d76cce02311bbb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Stoneworks Climbing Gym",
      "poi_type": "Entertainment",
      "poi_address": "6775 SW 111th Ave, Beaverton, OR 97008, USA",
      "poi_short_description": "Laid-back climbing gym with creative walls for top-roping, bouldering and lead climbing.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-007e-717c-a54e-42408850421a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-007e-717c-a54e-42408850421a",
        "storage_key": "property/6767906449166881/019d08ac-007e-717c-a54e-42408850421a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.belay.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10552377933223332491&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stoneworks-climbing-gym",
      "poi_latitude": "45.4719436",
      "poi_longitude": "-122.7906897",
      "poi_miles_from_property": "7.0 mi",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-644-3517",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlfCzCD8MlVQRi4pyRdKTcZI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "ec_3adbc98fd7cb05be7c30e519",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Tualatin Hills Nature Park",
      "poi_type": "Entertainment",
      "poi_address": "15655 SW Millikan Way, Beaverton, OR 97006, USA",
      "poi_short_description": "Hiking & biking trails along with playgrounds & sports facilities in a family-friendly public park.",
      "poi_long_description": "Hiking & biking trails along with playgrounds & sports facilities in a family-friendly public park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-01ab-77dd-b28d-09844a00719e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-01ab-77dd-b28d-09844a00719e",
        "storage_key": "property/6767906449166881/019d08ac-01ab-77dd-b28d-09844a00719e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/tualatin-hills-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17581483943034553182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-hills-nature-park",
      "poi_latitude": "45.4982312",
      "poi_longitude": "-122.8396247",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-645-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfj9vvMOlVQRXgPP2H76_fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_1a462ab628a722ed6dab78e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Patricia Reser Center for the Arts",
      "poi_type": "Entertainment",
      "poi_address": "12625 SW Crescent St, Beaverton, OR 97005, USA",
      "poi_short_description": "Upscale performing arts theater hosting shows, with an art gallery featuring local artists.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-05dc-7468-8a1b-33cab02f31e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-05dc-7468-8a1b-33cab02f31e9",
        "storage_key": "property/6767906449166881/019d08ac-05dc-7468-8a1b-33cab02f31e9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://thereser.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10286901166952613411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "patricia-reser-center-for-the-arts",
      "poi_latitude": "45.491325",
      "poi_longitude": "-122.807134",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 45 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 971-501-7722",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq6rq76EOlVQRIwbD5xtqwo4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "ec_76befc56d8157335a9562ddc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Play Street Museum - Beaverton",
      "poi_type": "Entertainment",
      "poi_address": "11221 NE Evergreen Pkwy Suite F, Hillsboro, OR 97006, USA",
      "poi_short_description": "Interactive museum and play area with educational exhibits and activities for kids 8 and under.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-081b-762a-9491-afb9b156fff4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-081b-762a-9491-afb9b156fff4",
        "storage_key": "property/6767906449166881/019d08ac-081b-762a-9491-afb9b156fff4.webp",
        "width": 1024,
        "height": 575
      },
      "poi_business_url": "https://beaverton.playstreetmuseum.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13212348074487731780&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "play-street-museum---beaverton",
      "poi_latitude": "45.5370712",
      "poi_longitude": "-122.8625165",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-470-3229",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6523-73d9-b3f9-d9841692c68c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6523-73d9-b3f9-d9841692c68c",
        "storage_key": "property/6767906449166881/019d08ac-6523-73d9-b3f9-d9841692c68c.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJRd4XlVwPlVQRRFaoXJKwW7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "ec_2cd1d0a4f4d940e4e73c338b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton City Park",
      "poi_type": "Entertainment",
      "poi_address": "12500 SW 4th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Urban green space featuring a seasonal splash fountain & picnic tables, plus benches & a playground.",
      "poi_long_description": "Urban green space featuring a seasonal splash fountain & picnic tables, plus benches & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-084e-7203-90fe-069db7c4de20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-084e-7203-90fe-069db7c4de20",
        "storage_key": "property/6767906449166881/019d08ac-084e-7203-90fe-069db7c4de20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beavertonoregon.gov/1246/City-Park-Fountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=1459461709017218379&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-city-park",
      "poi_latitude": "45.4838578",
      "poi_longitude": "-122.8055227",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 503-526-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5bubVSAMlVQRS31BGbEMQRQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_43608c00b29005e931a9b618",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton City Library",
      "poi_type": "Entertainment",
      "poi_address": "12375 SW 5th St, Beaverton, OR 97005, USA",
      "poi_short_description": "Multistory library with kids' areas, computers and board game rentals.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-0a47-76d1-9bbb-ccb9d728ed6b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0a47-76d1-9bbb-ccb9d728ed6b",
        "storage_key": "property/6767906449166881/019d08ac-0a47-76d1-9bbb-ccb9d728ed6b.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://beavertonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2456838086164544331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-city-library",
      "poi_latitude": "45.4840984",
      "poi_longitude": "-122.804071",
      "poi_miles_from_property": "5.2 mi",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-644-2197",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv_YnSyAMlVQRS_t89DhxGCI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "ec_7fafa04f9217f2277aa3e46c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "The Round | Beaverton",
      "poi_type": "Entertainment",
      "poi_address": "12600 SW Crescent St, Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-0f93-72b6-9f59-22fc4fbb02e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0f93-72b6-9f59-22fc4fbb02e7",
        "storage_key": "property/6767906449166881/019d08ac-0f93-72b6-9f59-22fc4fbb02e7.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://theroundbeaverton.com",
      "poi_directions_map_url": "https://maps.google.com/?cid=12170873754637210324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-round--beaverton",
      "poi_latitude": "45.49090169999999",
      "poi_longitude": "-122.8072173",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 503-954-2919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsZrC8I0yVUAR1JJGHzKh56g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "condominium_complex"
    },
    {
      "id": "ec_9f576e3bc8cf1a7ae68e6c15",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Providence St. Vincent Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "9205 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-0fdd-718c-9139-8543da9fc049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0fdd-718c-9139-8543da9fc049",
        "storage_key": "property/6767906449166881/019d08ac-0fdd-718c-9139-8543da9fc049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/st-vincent-medical-center?ls=location&y_source=1_OTU3NjM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1736548786178364168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-st-vincent-medical-center",
      "poi_latitude": "45.5103299",
      "poi_longitude": "-122.7720125",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6a71-75a7-b9d7-554febb9417f",
        "storage_key": "property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QPVf0QJlVQRCBNMn-t1GRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_0fc6f171a56d9c022fc4fc74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "OHSU Immediate Care Clinic, Beaverton",
      "poi_type": "Health and Wellness",
      "poi_address": "15700 SW Greystone Ct, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-1240-75f8-8e69-5282fa21f2f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-1240-75f8-8e69-5282fa21f2f0",
        "storage_key": "property/6767906449166881/019d08ac-1240-75f8-8e69-5282fa21f2f0.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.ohsu.edu/primary-care/ohsu-immediate-care-clinic-beaverton?utm_source=gmb&utm_medium=organic&utm_content=clinic-immediatecare-beaverton",
      "poi_directions_map_url": "https://maps.google.com/?cid=1962021650626090883&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ohsu-immediate-care-clinic-beaverton",
      "poi_latitude": "45.5139591",
      "poi_longitude": "-122.8383402",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 503-494-1700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzey-9tYPlVQRg5cxx0uAOhs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_7e373b98b66555fed1df737b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "ZoomCare Urgent Care - Tanasbourne",
      "poi_type": "Health and Wellness",
      "poi_address": "2711 NE Town Center Dr, Hillsboro, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-125b-70b6-bdfd-30d8ae3cf225.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-125b-70b6-bdfd-30d8ae3cf225",
        "storage_key": "property/6767906449166881/019d08ac-125b-70b6-bdfd-30d8ae3cf225.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.zoomcare.com/clinic/zoomcare-tanasbourne?utm_campaign=gmb-site&utm_source=google&utm_medium=maps&utm_content=tanasbourne",
      "poi_directions_map_url": "https://maps.google.com/?cid=6551870475271987467&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zoomcare-urgent-care---tanasbourne",
      "poi_latitude": "45.5391246",
      "poi_longitude": "-122.866698",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 844-966-6777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXZ6tPEMPlVQRC-H05Hvr7Fo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "ec_20a0b8691eee0adbf7ca6d1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Providence Immediate Care - Tanasbourne",
      "poi_type": "Health and Wellness",
      "poi_address": "10670 NE Cornell Rd Building B, Ste 101, Hillsboro, OR 97124, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-17d1-75be-a51c-0a4dd63ca771.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-17d1-75be-a51c-0a4dd63ca771",
        "storage_key": "property/6767906449166881/019d08ac-17d1-75be-a51c-0a4dd63ca771.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/urgent-care/or/immediate-care-tanasbourne?Is=location&y_source=1_OTU3NjEyNS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13215743495425729400&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-immediate-care---tanasbourne",
      "poi_latitude": "45.5330801",
      "poi_longitude": "-122.8697996",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-216-9360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJExC6GGoPlVQReKOHZ7DAZ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "ec_d44ad2a8b3893e6e52d66692",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "18101 NW Evergreen Pkwy, Beaverton, OR 97006, USA",
      "poi_short_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_long_description": "Drugstore chain selling a variety of beauty & health products, plus some grocery & household items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-d4a1-73ed-91a0-be77c2278ddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d4a1-73ed-91a0-be77c2278ddc",
        "storage_key": "property/6767906449166881/019d08ab-d4a1-73ed-91a0-be77c2278ddc.webp",
        "width": 720,
        "height": 480
      },
      "poi_business_url": "https://www.cvs.com/store-locator/beaverton-or-pharmacies/18101-nw-evergreen-pkwy-beaverton-or-97006/storeid=16336?WT.mc_id=LS_GOOGLE_RX_16336",
      "poi_directions_map_url": "https://maps.google.com/?cid=4428783883877281184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "45.5394315",
      "poi_longitude": "-122.8643345",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-207-0041",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eae-74c5-84a0-84db33932e5b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eae-74c5-84a0-84db33932e5b",
        "storage_key": "property/6767906449166881/019d08ac-5eae-74c5-84a0-84db33932e5b.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7ehxbkMPlVQRoO16SXozdj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "ec_439c035084b679c31f7ffc61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Walmart Neighborhood Market",
      "poi_type": "Health and Wellness",
      "poi_address": "17275 NW Cornell Rd, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ab-d4bd-77a8-8cde-7a617e1596b9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ab-d4bd-77a8-8cde-7a617e1596b9",
        "storage_key": "property/6767906449166881/019d08ab-d4bd-77a8-8cde-7a617e1596b9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walmart.com/store/5993-beaverton-or/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=7695010578633667457&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-neighborhood-market",
      "poi_latitude": "45.5354549",
      "poi_longitude": "-122.8525762",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-207-7627",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eae-74c5-84a0-83d31e8ec884",
        "storage_key": "property/6767906449166881/019d08ac-5eae-74c5-84a0-83d31e8ec884.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwbikl0cPlVQRgTNV8lkrymo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "ec_00d7baeb8a70f13285242e1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Rite Aid",
      "poi_type": "Health and Wellness",
      "poi_address": "12575 SW Walker Rd, Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-190e-732e-a0a2-7222530551bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-190e-732e-a0a2-7222530551bd",
        "storage_key": "property/6767906449166881/019d08ac-190e-732e-a0a2-7222530551bd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.riteaid.com/locations/or/beaverton/12575-sw-walker-road.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=14936781766809588482&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rite-aid",
      "poi_latitude": "45.5022037",
      "poi_longitude": "-122.8062614",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-646-2423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX56s-bkOlVQRApM34uAbSs8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "ec_9e5b9922852de93f68bfc686",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1265 NW Waterhouse Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-18bc-730e-897c-6bef3222f8a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-18bc-730e-897c-6bef3222f8a9",
        "storage_key": "property/6767906449166881/019d08ac-18bc-730e-897c-6bef3222f8a9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/beaverton-or/tanasbourne-super-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=11710869471339348612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "45.5275512",
      "poi_longitude": "-122.8373563",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-207-0452",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV0wx9jkPlVQRhAImwrxdhaI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_5af5efeb13bccc2579878410",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Club Pilates",
      "poi_type": "Health and Wellness",
      "poi_address": "2725 SW Cedar Hills Blvd #100, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain studio featuring group classes based on Joseph Pilates' Reformer-based method.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-19bc-71fd-9e09-60004e4275a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-19bc-71fd-9e09-60004e4275a4",
        "storage_key": "property/6767906449166881/019d08ac-19bc-71fd-9e09-60004e4275a4.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.clubpilates.com/cedarhills/?utm_source=google.com&utm_medium=referral&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1578626992955590544&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "club-pilates",
      "poi_latitude": "45.5006864",
      "poi_longitude": "-122.8090593",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-430-0693",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjZRsyyUPlVQRkAf22-Jo6BU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "ec_f50e49d5eff59e9b643a1435",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Bonfire Hot Yoga",
      "poi_type": "Health and Wellness",
      "poi_address": "11150 SW Allen Blvd Suite 160, Beaverton, OR 97005, USA",
      "poi_short_description": "Hot yoga is the specialty of this large studio, which also offers Vinyasa classes.",
      "poi_long_description": "Hot yoga is the specialty of this large studio, which also offers Vinyasa classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-213d-7018-8ade-794389b522fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-213d-7018-8ade-794389b522fa",
        "storage_key": "property/6767906449166881/019d08ac-213d-7018-8ade-794389b522fa.webp",
        "width": 1280,
        "height": 576
      },
      "poi_business_url": "http://bonfirehotyoga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10207186942825093998&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bonfire-hot-yoga",
      "poi_latitude": "45.4775611",
      "poi_longitude": "-122.7923028",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-526-8828",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJH4-3q6MOlVQRblsYy3E2p40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "ec_b1adea12d230fff733645471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Somerset Meadows Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3400 NW Parkview Dr, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-2199-7771-a1e0-7bc329466b81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2199-7771-a1e0-7bc329466b81",
        "storage_key": "property/6767906449166881/019d08ac-2199-7771-a1e0-7bc329466b81.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/somerset-meadows-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16427856216044529185&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "somerset-meadows-park",
      "poi_latitude": "45.5450493",
      "poi_longitude": "-122.8524405",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWQ9ksBcPlVQRIeaGojB4--M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_593735725327cf7495af5946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Somerset West Apartments",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18205 NW Bronson Rd, Portland, OR 97229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-21a7-7264-bc1f-400c3804c0f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-21a7-7264-bc1f-400c3804c0f2",
        "storage_key": "property/6767906449166881/019d08ac-21a7-7264-bc1f-400c3804c0f2.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.somersetwestprinceton.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5789966175269123333&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "somerset-west-apartments",
      "poi_latitude": "45.5419585",
      "poi_longitude": "-122.8650101",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 503-645-3923",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmewmtUQPlVQRBXVxUo8XWlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "apartment_complex"
    },
    {
      "id": "ec_f8ef3428a869b27da7a75cfc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Pioneer Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14545 NW Pioneer Rd, Beaverton, OR 97006, USA",
      "poi_short_description": "Venue offering a playground, basketball court & picnic tables, plus a trail through a natural area.",
      "poi_long_description": "Venue offering a playground, basketball court & picnic tables, plus a trail through a natural area.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/pioneer-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=7978829523615104681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pioneer-park",
      "poi_latitude": "45.5220715",
      "poi_longitude": "-122.8259548",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 971-246-0169",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJiQnXwSkPlVQRqT56li1_um4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_7ab47f4d3b7f8f2a388960b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Terra Linda Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "13855 NW Pettygrove St, Portland, OR 97229, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-22ec-75d8-9539-60299395f2a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-22ec-75d8-9539-60299395f2a8",
        "storage_key": "property/6767906449166881/019d08ac-22ec-75d8-9539-60299395f2a8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/terra-linda-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=11169567585025931172&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terra-linda-playground",
      "poi_latitude": "45.534485",
      "poi_longitude": "-122.8191444",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgy90pgsJlVQRpDcwKIpGAps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "ec_3b1087b1bca357e028370f3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Tualatin Hills Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15655 SW Millikan Way, Beaverton, OR 97006, USA",
      "poi_short_description": "Hiking & biking trails along with playgrounds & sports facilities in a family-friendly public park.",
      "poi_long_description": "Hiking & biking trails along with playgrounds & sports facilities in a family-friendly public park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-01ab-77dd-b28d-09844a00719e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-01ab-77dd-b28d-09844a00719e",
        "storage_key": "property/6767906449166881/019d08ac-01ab-77dd-b28d-09844a00719e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/tualatin-hills-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=17581483943034553182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tualatin-hills-nature-park",
      "poi_latitude": "45.4982312",
      "poi_longitude": "-122.8396247",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-645-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJWfj9vvMOlVQRXgPP2H76_fM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_779ba7b0a11254bce5ed52ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Cedar Hills Pickleball Court",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2300 SW Cedar Hills Blvd, Beaverton, OR 97005, USA",
      "poi_short_description": "Leafy park with areas for soccer, baseball, volleyball, tennis & bocce, plus a playground & paths.",
      "poi_long_description": "Leafy park with areas for soccer, baseball, volleyball, tennis & bocce, plus a playground & paths.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.thprd.org/parks-and-trails/detail/cedar-hills-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=16562607443780388453&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cedar-hills-pickleball-court",
      "poi_latitude": "45.5019476",
      "poi_longitude": "-122.8026951",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 503-645-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5_0Nw7AOlVQRZUbFuLcz2uU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4dfb879a2fb6ec48b95211c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Ridgecrest Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7594 SW Cresmoor Dr, Beaverton, OR 97008, USA",
      "poi_short_description": "Metal slides and swings are part of the fun at this laid-back park with tennis and basketball courts.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://thprd.org/parks/parkdetail.cfm?id=139",
      "poi_directions_map_url": "https://maps.google.com/?cid=1603624675551555210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ridgecrest-park",
      "poi_latitude": "45.46518589999999",
      "poi_longitude": "-122.8011492",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 503-629-6360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJf0Apv0kMlVQRii5NYyU4QRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_ff2897e62950b2fab99e7368",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Moshofsky Woods Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1001 NW Winged Foot Terrace, Beaverton, OR 97006, USA",
      "poi_short_description": "Park in the Tualatin Hills chain featuring a nature trail that's suitable for families.",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/moshofsky-woods-natural-area",
      "poi_directions_map_url": "https://maps.google.com/?cid=17217696931723801182&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "moshofsky-woods-park",
      "poi_latitude": "45.5271674",
      "poi_longitude": "-122.8486802",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 503-619-3962",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ3RJgzwPlVQRXvK62SKM8e4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_526e8c3ae38d26c2bc27c297",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Cooper Mountain Nature Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "18892 SW Kemmer Rd #5682, Beaverton, OR 97007, USA",
      "poi_short_description": "Scenic 230-acre park overlooking the river with multiple habitats, hiking trails & nature programs.",
      "poi_long_description": "Scenic 230-acre park overlooking the river with multiple habitats, hiking trails & nature programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-2911-71bc-bf6e-94f8691d3ac4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2911-71bc-bf6e-94f8691d3ac4",
        "storage_key": "property/6767906449166881/019d08ac-2911-71bc-bf6e-94f8691d3ac4.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.thprd.org/parks-and-trails/detail/cooper-mountain-nature-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=899869489749514377&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cooper-mountain-nature-park",
      "poi_latitude": "45.4524826",
      "poi_longitude": "-122.8712162",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 57 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 503-629-6350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64dd-74b5-961a-6f3f402c5db6",
        "storage_key": "property/6767906449166881/019d08ac-64dd-74b5-961a-6f3f402c5db6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJHZxuDwwSlVQRiVi7gIj6fAw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "ec_4b86a56c92e3a10851cc857a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton Transit center",
      "poi_type": "Transportation & Transit",
      "poi_address": "4050 SW Lombard Ave, Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-2a5a-72f9-8b2e-5ce6a7b10a16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2a5a-72f9-8b2e-5ce6a7b10a16",
        "storage_key": "property/6767906449166881/019d08ac-2a5a-72f9-8b2e-5ce6a7b10a16.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=4565063240923663999&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-transit-center",
      "poi_latitude": "45.49109660000001",
      "poi_longitude": "-122.8011257",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5wBVLnUPlVQRf85ytNRcWj8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transit_station"
    },
    {
      "id": "ec_9988121e4c5d9e54ffe92786",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton Central",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-2cb3-75bf-a18a-bca9600bbea3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2cb3-75bf-a18a-bca9600bbea3",
        "storage_key": "property/6767906449166881/019d08ac-2cb3-75bf-a18a-bca9600bbea3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trimet.org/ride/m/stop.html?stop_id=9823",
      "poi_directions_map_url": "https://maps.google.com/?cid=10105843167513541039&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-central",
      "poi_latitude": "45.49042590000001",
      "poi_longitude": "-122.8070926",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC6nm8qEOlVQRr_lzW9EqP4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_ce8dbb8faee9f0b4386d54f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Millikan Way",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-2e10-700f-a22b-3c3eb491c238.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-2e10-700f-a22b-3c3eb491c238",
        "storage_key": "property/6767906449166881/019d08ac-2e10-700f-a22b-3c3eb491c238.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14285898637418825828&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "millikan-way",
      "poi_latitude": "45.49523019999999",
      "poi_longitude": "-122.8216184",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0Zr7ZYOlVQRZAiW7B61QcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_09959197932734ab0a6576de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton Creek Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "SW Millikan Way, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-32b7-779f-b84c-6ba70d2316a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-32b7-779f-b84c-6ba70d2316a0",
        "storage_key": "property/6767906449166881/019d08ac-32b7-779f-b84c-6ba70d2316a0.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/parkandride/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5796149660367740647&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-creek-park-and-ride",
      "poi_latitude": "45.499036",
      "poi_longitude": "-122.8314458",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6b1c-7511-89af-0bac17eb4c7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6b1c-7511-89af-0bac17eb4c7e",
        "storage_key": "property/6767906449166881/019d08ac-6b1c-7511-89af-0bac17eb4c7e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJUXKnhZIOlVQR5144I2gPcFA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_c1e060082e70d757c47890bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Merlo Rd/SW 158th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-346c-765f-8901-42d59f187781.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-346c-765f-8901-42d59f187781",
        "storage_key": "property/6767906449166881/019d08ac-346c-765f-8901-42d59f187781.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://trimet.org/ride/m/stop.html?stop_id=9828",
      "poi_directions_map_url": "https://maps.google.com/?cid=5872101437146888542&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "merlo-rdsw-158th-ave",
      "poi_latitude": "45.505228",
      "poi_longitude": "-122.842148",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh0-6de8OlVQRXnkzNiXlfVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_501c86a409e3be686782af02",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Elmonica/SW 170th Ave",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-372c-7278-b7c4-f9fa51024c07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-372c-7278-b7c4-f9fa51024c07",
        "storage_key": "property/6767906449166881/019d08ac-372c-7278-b7c4-f9fa51024c07.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://trimet.org/ride/stop.html?id=9829",
      "poi_directions_map_url": "https://maps.google.com/?cid=12242366764481047543&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elmonicasw-170th-ave",
      "poi_latitude": "45.5099231",
      "poi_longitude": "-122.8515139",
      "poi_miles_from_property": "2.8 mi",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-c6QOOMOlVQR9-vwnrWf5ak",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "light_rail_station"
    },
    {
      "id": "ec_5c33f75f1eb91de58211caee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Sunset Transit Center Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "10470 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-36df-77f4-b0e2-afa30475fc39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-36df-77f4-b0e2-afa30475fc39",
        "storage_key": "property/6767906449166881/019d08ac-36df-77f4-b0e2-afa30475fc39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://trimet.org/transitcenters/sunset.htm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10582984853125739554&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sunset-transit-center-park--ride",
      "poi_latitude": "45.5106914",
      "poi_longitude": "-122.7823343",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-238-7433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6b1c-7511-89af-0bac17eb4c7e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6b1c-7511-89af-0bac17eb4c7e",
        "storage_key": "property/6767906449166881/019d08ac-6b1c-7511-89af-0bac17eb4c7e.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJrStGIkYJlVQRIjTmIadQ3pI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "ec_2ac1eb5418b12f85b05f001a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Washington Square Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Tigard, OR 97223, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-3b8d-7407-ac42-bdc9a5e9b8e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3b8d-7407-ac42-bdc9a5e9b8e0",
        "storage_key": "property/6767906449166881/019d08ac-3b8d-7407-ac42-bdc9a5e9b8e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3751353937186555184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-square-transit-center",
      "poi_latitude": "45.4527",
      "poi_longitude": "-122.77881",
      "poi_miles_from_property": "8.1 mi",
      "poi_walking_minutes": "3 hours 2 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZeBK_vcMlVQRMIXExId8DzQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "ec_acacf10609c15d1b7b39f2ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Portland International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "7000 NE Airport Way, Portland, OR 97218, USA",
      "poi_short_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_long_description": "Hub featuring direct rail service to Downtown, plus works by regional artists & frequent live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-3d11-750e-9978-54a899511822.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-3d11-750e-9978-54a899511822",
        "storage_key": "property/6767906449166881/019d08ac-3d11-750e-9978-54a899511822.webp",
        "width": 1000,
        "height": 668
      },
      "poi_business_url": "https://www.flypdx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6618732977047100477&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "portland-international-airport",
      "poi_latitude": "45.5852698",
      "poi_longitude": "-122.5917184",
      "poi_miles_from_property": "18.5 mi",
      "poi_walking_minutes": "7 hours 0 mins",
      "poi_biking_minutes": "2 hours 18 mins",
      "poi_driving_minutes": "35 mins",
      "poi_business_phone": "+1 503-460-4234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6b5a-731c-a7d2-c46c2924ba4f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6b5a-731c-a7d2-c46c2924ba4f",
        "storage_key": "property/6767906449166881/019d08ac-6b5a-731c-a7d2-c46c2924ba4f.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0SDcdKqglVQRPVwOOJN22ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "ec_90d666fa0d7865b56d92e6a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Nike World Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "One Bowerman Dr, Beaverton, OR 97005, USA",
      "poi_short_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_long_description": "Chain retailer selling a range of Nike athletic footwear, apparel & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-4068-72ff-8f84-73d7aac8babe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4068-72ff-8f84-73d7aac8babe",
        "storage_key": "property/6767906449166881/019d08ac-4068-72ff-8f84-73d7aac8babe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://about.nike.com/pages/contact-us",
      "poi_directions_map_url": "https://maps.google.com/?cid=12026902182619501264&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nike-world-headquarters",
      "poi_latitude": "45.5075349",
      "poi_longitude": "-122.8272752",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 503-671-6453",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbaRNTcIOlVQR0NJnV9Aj6KY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_319b49d1e2a6b1f9af66f071",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Intel Gordon Moore Park at Ronler Acres",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2501 NE Century Blvd, Hillsboro, OR 97124, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-4190-739f-b50b-680b7baa9743.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4190-739f-b50b-680b7baa9743",
        "storage_key": "property/6767906449166881/019d08ac-4190-739f-b50b-680b7baa9743.webp",
        "width": 1280,
        "height": 997
      },
      "poi_business_url": "http://www.intel.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8328745523481169069&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "intel-gordon-moore-park-at-ronler-acres",
      "poi_latitude": "45.54101319999999",
      "poi_longitude": "-122.9168708",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 408-765-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ28RnPXkFlVQRrUy4D-2llXM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_51de1353208da434f029db97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Columbia Sportswear Corporate Headquarters",
      "poi_type": "Major Employers & Offices",
      "poi_address": "14375 NW Science Park Dr, Portland, OR 97229, USA",
      "poi_short_description": "Retail chain with house-brand outdoor apparel, footwear & accessories for adults & kids.",
      "poi_long_description": "Retail chain with house-brand outdoor apparel, footwear & accessories for adults & kids.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-440d-76bf-a351-6bf97037e693.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-440d-76bf-a351-6bf97037e693",
        "storage_key": "property/6767906449166881/019d08ac-440d-76bf-a351-6bf97037e693.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.columbia.com/stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=7187076593379096042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "columbia-sportswear-corporate-headquarters",
      "poi_latitude": "45.5296292",
      "poi_longitude": "-122.825021",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-985-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-56db-7084-bc6c-97eef4dd7cc4",
        "storage_key": "property/6767906449166881/019d08ac-56db-7084-bc6c-97eef4dd7cc4.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2652iywPlVQR6rXiORWgvWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "ec_5ae5b900e3e59e89c56f7bad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Tektronix",
      "poi_type": "Major Employers & Offices",
      "poi_address": "13725 SW Karl Braun Dr, Beaverton, OR 97077, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-437c-70d5-9013-6979802b5b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-437c-70d5-9013-6979802b5b17",
        "storage_key": "property/6767906449166881/019d08ac-437c-70d5-9013-6979802b5b17.webp",
        "width": 1280,
        "height": 531
      },
      "poi_business_url": "https://www.tek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15636940881747062254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tektronix",
      "poi_latitude": "45.4990886",
      "poi_longitude": "-122.823319",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 800-833-9200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ679dZUOlVQR7i1RRuKSAdk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "ec_9ce87063a2640b56987ceb60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Kaiser Permanente Westside Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2875 NE Stucki Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-4942-773e-b21a-073f35b47553.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4942-773e-b21a-073f35b47553",
        "storage_key": "property/6767906449166881/019d08ac-4942-773e-b21a-073f35b47553.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://healthy.kaiserpermanente.org/oregon-washington/facilities/Kaiser-Permanente-Westside-Medical-Center-303481",
      "poi_directions_map_url": "https://maps.google.com/?cid=3776957816373943267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kaiser-permanente-westside-medical-center",
      "poi_latitude": "45.5394893",
      "poi_longitude": "-122.8767522",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-813-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6a71-75a7-b9d7-554febb9417f",
        "storage_key": "property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJfRNRTGYPlVQR45uacB9zajQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_369135083b1a1c8d249e01b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Providence St. Vincent Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9205 SW Barnes Rd, Portland, OR 97225, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-0fdd-718c-9139-8543da9fc049.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-0fdd-718c-9139-8543da9fc049",
        "storage_key": "property/6767906449166881/019d08ac-0fdd-718c-9139-8543da9fc049.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.providence.org/locations/or/st-vincent-medical-center?ls=location&y_source=1_OTU3NjM5Ni03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1736548786178364168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "providence-st-vincent-medical-center",
      "poi_latitude": "45.5103299",
      "poi_longitude": "-122.7720125",
      "poi_miles_from_property": "5.0 mi",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 503-216-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6a71-75a7-b9d7-554febb9417f",
        "storage_key": "property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1QPVf0QJlVQRCBNMn-t1GRg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_fbd28dd134218e9fe8dbc704",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Hillsboro Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "335 SE 8th Ave, Hillsboro, OR 97123, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-4be7-75d8-9d44-0bf1f95526c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4be7-75d8-9d44-0bf1f95526c6",
        "storage_key": "property/6767906449166881/019d08ac-4be7-75d8-9d44-0bf1f95526c6.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tuality.org/location/hospitals/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9950683274343401642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hillsboro-medical-center",
      "poi_latitude": "45.51965879999999",
      "poi_longitude": "-122.9778909",
      "poi_miles_from_property": "8.3 mi",
      "poi_walking_minutes": "3 hours 3 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 503-681-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6a71-75a7-b9d7-554febb9417f",
        "storage_key": "property/6767906449166881/019d08ac-6a71-75a7-b9d7-554febb9417f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJBc-XeqYalVQRqsioj7ftF4o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "ec_b9dd56f71c422aff80923913",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Public Services Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "155 N 1st Ave, Hillsboro, OR 97124, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-4ddb-70c8-94c1-6831bfba72d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4ddb-70c8-94c1-6831bfba72d5",
        "storage_key": "property/6767906449166881/019d08ac-4ddb-70c8-94c1-6831bfba72d5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.washingtoncountyor.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15755227402135792277&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "public-services-building",
      "poi_latitude": "45.5233078",
      "poi_longitude": "-122.9904389",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 503-846-8685",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-6b1a-777e-bbbe-4b3505384bb6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-6b1a-777e-bbbe-4b3505384bb6",
        "storage_key": "property/6767906449166881/019d08ac-6b1a-777e-bbbe-4b3505384bb6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJY8Y_lbwalVQRlerN89jPpdo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "ec_93b24e6448bbd198327d350d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "12725 SW Millikan Way",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12725 SW Millikan Way, Beaverton, OR 97005, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=13419993934985890880&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "12725-sw-millikan-way",
      "poi_latitude": "45.4897998",
      "poi_longitude": "-122.8065725",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-64e7-7367-9144-d6dbe3b40f67",
        "storage_key": "property/6767906449166881/019d08ac-64e7-7367-9144-d6dbe3b40f67.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4UZswKEOlVQRQAy7tmFlPbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "premise"
    },
    {
      "id": "ec_59af386f0202bf10c1962891",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "poi_name": "Beaverton School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1260 NW Waterhouse Ave, Beaverton, OR 97006, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-4f6d-76af-85b8-f06a2c35919c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08ac-4f6d-76af-85b8-f06a2c35919c",
        "storage_key": "property/6767906449166881/019d08ac-4f6d-76af-85b8-f06a2c35919c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beaverton.k12.or.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7150557257484604500&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaverton-school-district",
      "poi_latitude": "45.5265873",
      "poi_longitude": "-122.838989",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 503-356-4500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08ac-5eea-7278-9730-2933d305d7fe",
        "storage_key": "property/6767906449166881/019d08ac-5eea-7278-9730-2933d305d7fe.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4S1WevAOlVQRVBR2vvDhO2M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_afa2860e78ec7d76db01ab40",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_bd3d9d97dfa06fb8b2a122e5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_52d40b87e5f89f8fdba2413f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_d54b6103fab5a693e0a21a44",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_abe68611100857f3a0fa4170",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_653667ca9b872aa157878b77",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "SAT",
      "open_time": "09:00",
      "close_time": "17:30"
    },
    {
      "id": "ec_af452dc4e1969f0fb3aeb237",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "day": "SUN",
      "open_time": "10:00",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "ec_d68823304504dd639f8d987c",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "rating": "5",
      "name": "false",
      "text": "Great family & pet friendly complex! Extremely close to easy freeway access to both downtown Portland and 1.5 hrs from the ocean!\n\nOffice staff is amazing & the most friendly I've ever met. They actually take the effort to get to know you. Maintenance gets done within 24 hours of being reported & the office makes sure to follow up no matter how small the request to ensure the job got done & to your liking. Both the maintenance team & office staff take the effort to wave & say \"Hi\" whenever you are around the complex.\n\nThe apartments have nice layouts with no wasted space!! The top floors have vaulted ceilings which make the apartments seem more open. Some homes even come with covered parking spots. Homes have plenty of closet space and great covered patios.",
      "date": "false",
      "title": "Great Place W/Even Better Location"
    },
    {
      "id": "ec_aa245538e652b900ef91d868",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "rating": "5",
      "name": "false",
      "text": "pros:\nlower rates\n\ncons:\noutdated apliances\noutdated building structure \nterrible maintenance staff\nrude office staff",
      "date": "false",
      "title": "you get what you pay for"
    },
    {
      "id": "ec_13c8147825c4ed3cdad2c9c5",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "rating": "5",
      "name": "false",
      "text": "moved here  from NY and it was the greatest decision ever. a gym, a spa, a pool are all included. most of all, I love living with my boyfriend.",
      "date": "false",
      "title": "love this place"
    },
    {
      "id": "ec_6bf91657df479c0d52c0a4f3",
      "source": "apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "rating": "5",
      "name": "false",
      "text": "Just settled into my new apartment and I have to say, the whole experience leading up to it was fantastic! The leasing team was amazing, always available to answer my questions and make everything stress-free. The place itself is not only pristine, but it also has this warm and inviting atmosphere that already feels like home. Sorting out the lease was surprisingly simple too, they really went out of their way to accommodate my preferences and the community here is incredibly welcoming. Overall, I'm thrilled to call this place home!",
      "date": "false",
      "title": "Top Notch "
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_e10116a69121a386a354eeda",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ad-c274-709d-a966-dcc042bd737c.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living area and kitchen with sliding glass doors to a patio",
        "public_id": "019d08ad-c274-709d-a966-dcc042bd737c",
        "storage_key": "property/6767906449166881/019d08ad-c274-709d-a966-dcc042bd737c.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "3BR, 2BA - 1,105SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=2tVu9qvdtUi"
    },
    {
      "id": "ec_2499dd3bc8359a9ba7986b86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "apartments",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166881/019d08ad-c275-73d9-a784-09c76ff7a306.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room and dining area with plush seating and a kitchen view",
        "public_id": "019d08ad-c275-73d9-a784-09c76ff7a306",
        "storage_key": "property/6767906449166881/019d08ad-c275-73d9-a784-09c76ff7a306.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 896SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=7axmdrdgMD4"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a9d1b-3f37-7233-94f1-5c472b50cc19",
      "lead_source": "LANDING_PAGE",
      "name": "CTL-management-sir-charles-court-lp",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "apartments-with-pool-beaverton-or-sir-charles-court",
      "search_query": "apartments with pool in Beaverton OR",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Beaverton, OR",
      "h2_subtitle": "Find the perfect apartment with a pool at Sir Charles Court. Enjoy the luxury of swimming right at home, located in vibrant Beaverton, OR.",
      "page_copy": "Looking for apartments with a pool in Beaverton, OR? Sir Charles Court offers not only a fantastic swimming pool but also a hot tub for ultimate relaxation. Nestled in the charming Oak Hills neighborhood, our community provides a serene escape while being conveniently located in Washington County.\n\nResidents of Sir Charles Court benefit from a modern kitchen and stylish vinyl flooring that make everyday living a pleasure. With added conveniences like disposal, our apartments cater to those seeking both functionality and comfort. Dive into luxury with access to our exclusive amenities and discover why Sir Charles Court is the ideal choice for your next home in Beaverton, OR.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Beaverton, OR",
      "seo_description": "Discover Sir Charles Court, offering apartments with a pool in Beaverton, OR. Enjoy modern amenities and a vibrant community just for you.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-washington-county-sir-charles-court",
      "search_query": "fitness center apartments in Washington County",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in Washington County",
      "h2_subtitle": "Sir Charles Court offers comfortable living in apartments with easy access to fitness options in Washington County. Enjoy an active lifestyle in Beaverton, OR.",
      "page_copy": "For those seeking fitness center apartments in Washington County, Sir Charles Court is a perfect choice. While we do not have an on-site fitness center, our location in Beaverton provides numerous fitness facilities nearby, ensuring residents can maintain an active lifestyle.\n\nSituated in the peaceful Oak Hills neighborhood, our apartments offer top-tier amenities such as a luxurious pool and hot tub. Each apartment is equipped with a modern kitchen, vinyl flooring, and convenient disposal service, making Sir Charles Court a wonderful place to call home. Experience the best of both worlds—a tranquil living environment with easy access to local fitness centers in Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments in Washington County",
      "seo_description": "Explore Sir Charles Court, offering comfortable apartments near fitness centers in Washington County, OR. Enjoy nearby facilities and superior amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "family-friendly-apartments-oak-hills-sir-charles-court",
      "search_query": "family-friendly apartments with playground in Oak Hills",
      "category": "Amenity",
      "h1_title": "Family-Friendly Apartments, Oak Hills",
      "h2_subtitle": "Discover family-friendly apartments in Oak Hills at Sir Charles Court. While there isn't a playground, enjoy safe, community-focused living.",
      "page_copy": "Sir Charles Court offers family-friendly apartments in the beautiful Oak Hills neighborhood. While our community doesn’t include a playground on-site, the area is rich with nearby parks and recreational areas that make it perfect for family outings.\n\nOur amenities are designed for comfort, featuring a refreshing pool and relaxing hot tub—ideal for family relaxation and fun. Inside, each apartment boasts a modern kitchen and stylish vinyl flooring, ensuring everyday living is both easy and enjoyable. Located in Beaverton within Washington County, Sir Charles Court provides a warm and inviting atmosphere that every family will love.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Family-Friendly Apartments, Oak Hills",
      "seo_description": "Explore Sir Charles Court's family-friendly apartments in Oak Hills. Enjoy safe living with access to nearby parks and community amenities in Beaverton, OR.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "apartments-with-walk-in-closets-beaverton-97006",
      "search_query": "apartments with walk-in closets Beaverton 97006",
      "category": "Amenity",
      "h1_title": "Apartments with Walk-In Closets in Beaverton 97006",
      "h2_subtitle": "Sir Charles Court in Beaverton 97006 offers spacious apartments that cater to your storage needs. Discover ample space and modern amenities here.",
      "page_copy": "Searching for apartments with walk-in closets in Beaverton 97006? While Sir Charles Court offers many great amenities, such as a pool and hot tub, walk-in closets are not featured. However, our apartments are thoughtfully designed to maximize space with modern kitchens and stylish vinyl flooring that create a welcoming ambiance.\n\nLocated in the Oak Hills neighborhood within Washington County, our community provides easy access to all that Beaverton has to offer. Residents enjoy a blend of suburban tranquility and urban convenience, making Sir Charles Court an excellent choice for your next home in the 97006 area.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Walk-In Closets, Beaverton 97006",
      "seo_description": "Explore Sir Charles Court in Beaverton 97006 for modern apartments with desirable amenities and a convenient location in Washington County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "luxury-apartments-clubhouse-beaverton-or-sir-charles-court",
      "search_query": "luxury apartments with clubhouse in Beaverton OR",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Clubhouse in Beaverton, OR",
      "h2_subtitle": "Discover the charm of luxury apartments in Beaverton, OR at Sir Charles Court. Although we don't have a clubhouse, our community offers premium amenities.",
      "page_copy": "For those seeking luxury apartments with a clubhouse in Beaverton, OR, Sir Charles Court presents a compelling option. While a dedicated clubhouse isn't part of our amenities, residents can indulge in our relaxing pool and hot tub—a great way to unwind in style.\n\nSituated in the quaint Oak Hills neighborhood, our apartments offer elegance and comfort with modern kitchens and chic vinyl flooring. Enjoy the convenience of living in Washington County, with easy access to local attractions. Sir Charles Court perfectly blends luxury living with community charm, making it a delightful place to reside.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Clubhouse, Beaverton OR",
      "seo_description": "Explore Sir Charles Court for luxury living in Beaverton, OR. While we lack a clubhouse, enjoy premier amenities like a pool and hot tub.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-beaverton-or-sir-charles-court",
      "search_query": "one bedroom apartments Beaverton OR",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Beaverton, OR",
      "h2_subtitle": "Explore one bedroom apartments in Beaverton, OR at Sir Charles Court. Enjoy modern living with convenient amenities in a vibrant neighborhood.",
      "page_copy": "At Sir Charles Court, our one bedroom apartments in Beaverton, OR are designed for comfortable, modern living. Each unit offers a well-appointed kitchen and elegant vinyl flooring, ensuring a stylish and practical lifestyle in the heart of Oak Hills.\n\nLocated in Washington County, our community is more than just a place to live—it's a welcoming environment with amenities like a pool and hot tub, perfect for unwinding. Enjoy the best of Beaverton with local shops, dining, and parks just minutes away. Sir Charles Court offers a one bedroom living experience that blends convenience with community charm.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Beaverton, OR",
      "seo_description": "Discover Sir Charles Court's one bedroom apartments in Beaverton, OR. Enjoy modern amenities in the welcoming Oak Hills neighborhood.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-washington-county-sir-charles-court",
      "search_query": "2 bedroom apartments Washington County",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Washington County",
      "h2_subtitle": "Discover spacious 2 bedroom apartments at Sir Charles Court in Washington County. Enjoy a blend of comfort and convenience in a prime location.",
      "page_copy": "Sir Charles Court offers 2 bedroom apartments in the heart of Washington County, providing ample space and modern amenities for comfortable living. Our community features thoughtfully designed interiors with stylish vinyl flooring and contemporary kitchens, perfect for entertaining and everyday life.\n\nLocated in Beaverton’s Oak Hills neighborhood, Sir Charles Court combines suburban charm with urban accessibility. Residents can enjoy quality time by the pool or relax in the hot tub, making it a perfect home base all year round. Discover how our 2 bedroom options can meet your lifestyle needs in beautiful Washington County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments, Washington County",
      "seo_description": "Explore Sir Charles Court’s 2 bedroom apartments in Washington County. Enjoy spacious living with modern amenities in the heart of Beaverton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162446",
      "property_id": "6767906449166881",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-oak-hills-sir-charles-court",
      "search_query": "three bedroom apartments near Oak Hills",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near Oak Hills",
      "h2_subtitle": "Check out spacious three bedroom apartments near Oak Hills at Sir Charles Court. Ideal for larger households looking for space and convenience.",
      "page_copy": "If you're searching for three bedroom apartments near Oak Hills, Sir Charles Court offers an exceptional choice. Our spacious units accommodate larger households, providing plenty of room with modern amenities like a fully-equipped kitchen and elegant vinyl flooring.\n\nNestled in the vibrant community of Beaverton, our residents enjoy easy access to local shops, dining, and entertainment options. The amenities at Sir Charles Court, including a refreshing pool and soothing hot tub, are perfect for relaxation. Discover the perfect blend of space and community near Oak Hills at Sir Charles Court.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Near Oak Hills",
      "seo_description": "Explore Sir Charles Court's three bedroom apartments near Oak Hills. Enjoy spacious living and various amenities in the heart of Beaverton.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5604"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18372403683"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-TCK3XBWG"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "52024037808"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-644-5721"
    }
  ],
  "custom_qb_id": "5604",
  "custom_repli_id": "18372403683",
  "custom_google_gtm_id": "GTM-TCK3XBWG",
  "custom_hubspot_company_id": "52024037808",
  "custom_ppc_tracking_phone_number": "844-644-5721"
};

export const generatedAt = '2026-10-05T21:10:48.971Z';
